import { CloseOutlined } from '@ant-design/icons';
import { Autocomplete, FormControlLabel, IconButton, Select, Tooltip, Typography, useTheme } from '@mui/material';
import { Grid } from '@mui/material';
import MainCard from 'components/MainCard';
import { CopyTradingTableDto, filter_type_map_value } from '../CopyTradingTableSection';
import { useEffect, useRef, useState } from 'react';
import EditableTable from '../EditableTable';
// import ScrollX from 'components/ScrollX';
import { Form, Formik } from 'formik';
import { TextField } from '@mui/material';
import { MenuItem } from '@mui/material';
import { FormHelperText } from '@mui/material';
import { FormControl } from '@mui/material';
import { OutlinedInput } from '@mui/material';
import { RISK_TYPE, Slave, UpdatedSlaveConfig, UpdateSlaveManyReq, UpdateSlaveReq } from 'proto/trade-copier_pb';
import { Stack } from '@mui/material';
import { Crisp } from 'crisp-sdk-web';
// import { InputAdornment } from '@mui/material';
import * as Yup from 'yup';
import { Row } from 'react-table';
import useAuth from 'hooks/useAuth';
import { Checkbox } from '@mui/material';
import { Button } from '@mui/material';
import LoadingButton from 'components/@extended/LoadingButton';
import { InputAdornment } from '@mui/material';
import './BulkEditSlaveTable.css';
import { mt4Options, mt5Options } from '../AddCopierSection';
import { Int64Value, StringValue } from 'google-protobuf/google/protobuf/wrappers_pb';
import { DispatchSnackbarService } from 'services';
import { useDispatch } from 'store';
import { useTradeClient } from 'client/client-hook';
import { TradeClient } from 'client/client';

type Props = {
  handleClose: () => void;
  handleSuccess: () => void;
  selectedMaster: CopyTradingTableDto;
  selectedSlaves: CopyTradingTableDto[];
};

const initialRowFixed: any = { accountName: 'All Slaves' };
const service = new DispatchSnackbarService();

const BulkEditSlaveTable = ({ handleClose, handleSuccess, selectedMaster, selectedSlaves }: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  const theme = useTheme();
  const { user } = useAuth();
  const dispatch = useDispatch();
  const tradeClient = useTradeClient();

  const [data, setData] = useState<CopyTradingTableDto[]>([initialRowFixed, ...selectedSlaves]);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      updateInitialRow(true);
      isFirstRender.current = false;
    } else {
      updateInitialRow();
    }
  }, [selectedSlaves, data]);

  const updateInitialRow = (init: boolean = false) => {
    const newData = [...data];
    console.log('UPDATED INIT DATA: ', data);

    if (newData.length > 0) {
      const firstItem = newData[0];

      const copySL = (init ? newData.slice(1) : newData).every((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.copyStopLoss?.value ?? old?.copyStopLoss?.value;
      });

      const copyTP = (init ? newData.slice(1) : newData).every((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.copyTakeProfit?.value ?? old?.copyTakeProfit?.value;
      });

      const copyPendingOrders = (init ? newData.slice(1) : newData).every((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.copyPendingOrders?.value ?? old?.copyPendingOrders?.value;
      });

      const riskTypeValues = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.riskType?.value ? riskTypeMapFromKey[updated.riskType.value] : riskTypeMapFromKey[old?.riskType?.value || ''];
      });
      const allRiskTypesSame = riskTypeValues.every((value, index, array) => value === array[0]);

      const lotMultiplierValues = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.lotMultiplierValue?.value
          ? updated?.lotMultiplierValue?.value
          : old?.lotMultiplierValue?.value
          ? old?.lotMultiplierValue?.value
          : 0;
      });
      const lotMultiplierValuesSame = lotMultiplierValues.every((value, index, array) => value === array[0]);
      const lotMultiplierValue = lotMultiplierValuesSame ? { value: lotMultiplierValues[0] || 0 } : undefined;

      const fixedLotValues = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.fixedLotValue?.value ? updated?.fixedLotValue?.value : old?.fixedLotValue?.value ? old?.fixedLotValue?.value : 0;
      });
      const fixedLotValuesSame = fixedLotValues.every((value, index, array) => value === array[0]);
      const fixedLotValue = fixedLotValuesSame ? { value: fixedLotValues[0] || 0 } : undefined;

      const balanceMultiplierValues = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.balanceMultiplierValue?.value
          ? updated?.balanceMultiplierValue?.value
          : old?.balanceMultiplierValue?.value
          ? old?.balanceMultiplierValue?.value
          : 0;
      });
      const balanceMultiplierValuesSame = balanceMultiplierValues.every((value, index, array) => value === array[0]);
      const balanceMultiplierValue = balanceMultiplierValuesSame ? { value: balanceMultiplierValues[0] || 0 } : undefined;

      const balancePercentageValues = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.balancePercentageValue?.value
          ? updated?.balancePercentageValue?.value
          : old?.balancePercentageValue?.value
          ? old?.balancePercentageValue?.value
          : 0;
      });
      const balancePercentageValuesSame = balancePercentageValues.every((value, index, array) => value === array[0]);
      const balancePercentageValue = balancePercentageValuesSame ? { value: balancePercentageValues[0] || 0 } : undefined;

      const fixedBalanceMultiplierValues = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.fixedBalanceMultiplierValue?.value
          ? updated?.fixedBalanceMultiplierValue?.value
          : old?.fixedBalanceMultiplierValue?.value
          ? old?.fixedBalanceMultiplierValue?.value
          : 0;
      });
      const fixedBalanceMultiplierValuesSame = fixedBalanceMultiplierValues.every((value, index, array) => value === array[0]);
      const fixedBalanceMultiplierValue = fixedBalanceMultiplierValuesSame ? { value: fixedBalanceMultiplierValues[0] || 0 } : undefined;

      const fixedMasterBalances = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.fixedMasterBalance?.value
          ? updated?.fixedMasterBalance?.value
          : old?.fixedMasterBalance?.value
          ? old?.fixedMasterBalance?.value
          : 0;
      });
      const fixedMasterBalancesSame = fixedMasterBalances.every((value, index, array) => value === array[0]);
      const fixedMasterBalance = fixedMasterBalancesSame ? { value: fixedMasterBalances[0] || 0 } : undefined;

      const stopLossPips = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.stopLossPip?.value ? updated?.stopLossPip?.value || 0 : old?.stopLossPip?.value || 0;
      });
      const stopLossPipsSame = stopLossPips.every((value, index, array) => value === array[0]);
      const stopLossPip = stopLossPipsSame ? { value: stopLossPips[0] || 0 } : undefined;

      const takeProfitPips = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.takeProfitPip?.value ? updated?.takeProfitPip?.value || 0 : old?.takeProfitPip?.value || 0;
      });
      const takeProfitPipsSame = takeProfitPips.every((value, index, array) => value === array[0]);
      const takeProfitPip = takeProfitPipsSame ? { value: takeProfitPips[0] || 0 } : undefined;

      const slRefiners = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.slRefiner?.value ? updated?.slRefiner?.value || 0 : old?.slRefiner?.value || 0;
      });
      const slRefinersSame = slRefiners.every((value, index, array) => value === array[0]);
      const slRefiner = slRefinersSame ? { value: slRefiners[0] || 0 } : undefined;

      const tpRefiners = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.tpRefiner?.value ? updated?.tpRefiner?.value || 0 : old?.tpRefiner?.value || 0;
      });
      const tpRefinersSame = tpRefiners.every((value, index, array) => value === array[0]);
      const tpRefiner = tpRefinersSame ? { value: tpRefiners[0] || 0 } : undefined;

      const forceMinimumLotSize = (init ? newData.slice(1) : newData).every((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.forceMinimumLotSize?.value ?? old?.forceMinimumLotSize?.value;
      });

      const forceMaximumLotSize = (init ? newData.slice(1) : newData).every((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.forceMaximumLotSize?.value ?? old?.forceMaximumLotSize?.value;
      });

      const reverseTrade = (init ? newData.slice(1) : newData).every((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.reverseTrade?.value ?? old?.reverseTrade?.value;
      });

      const strictClose = (init ? newData.slice(1) : newData).every((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.strictClose?.value ?? old?.strictClose?.value;
      });

      const considerContractSize = (init ? newData.slice(1) : newData).every((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.considerContractSize?.value ?? old?.considerContractSize?.value;
      });

      const copyExpiryTime = (init ? newData.slice(1) : newData).every((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.copyExpiryTime?.value ?? old?.copyExpiryTime?.value;
      });

      const minLotFilters = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.minLotFilter?.value || updated?.minLotFilter?.value === 0
          ? updated?.minLotFilter?.value || 0
          : old?.minLotFilter?.value || 0;
      });
      const minLotFiltersSame = minLotFilters.every((value, index, array) => value === array[0]);
      const minLotFilter = minLotFiltersSame ? { value: minLotFilters[0] || 0 } : undefined;

      const maxLotFilters = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.maxLotFilter?.value || updated?.maxLotFilter?.value === 0
          ? updated?.maxLotFilter?.value || 0
          : old?.maxLotFilter?.value || 0;
      });
      const maxLotFiltersSame = maxLotFilters.every((value, index, array) => value === array[0]);
      const maxLotFilter = maxLotFiltersSame ? { value: maxLotFilters[0] || 0 } : undefined;

      const lotRefinerValues = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.lotRefinerValue?.value ? updated?.lotRefinerValue?.value || 0 : old?.lotRefinerValue?.value || 0;
      });
      const lotRefinerValuesSame = lotRefinerValues.every((value, index, array) => value === array[0]);
      const lotRefinerValue = lotRefinerValuesSame ? { value: lotRefinerValues[0] || 0 } : undefined;

      const minDelayTimes = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.minDelayTime?.value || updated?.minDelayTime?.value === 0
          ? updated?.minDelayTime?.value || 0
          : old?.minDelayTime?.value || 0;
      });
      const minDelayTimesSame = minDelayTimes.every((value, index, array) => value === array[0]);
      const minDelayTime = minDelayTimesSame ? { value: minDelayTimes[0] || 0 } : undefined;

      const maxDelayTimes = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.maxDelayTime?.value || updated?.maxDelayTime?.value === 0
          ? updated?.maxDelayTime?.value || 0
          : old?.maxDelayTime?.value || 0;
      });
      const maxDelayTimesSame = maxDelayTimes.every((value, index, array) => value === array[0]);
      const maxDelayTime = maxDelayTimesSame ? { value: maxDelayTimes[0] || 0 } : undefined;

      const delayTypeSet = new Set();
      for (let i = 0; i < minDelayTimes.length; i++) {
        if (minDelayTimes[i] <= 0 || maxDelayTimes[i] <= 0) {
          delayTypeSet.add('no');
        } else if (minDelayTimes[i] !== maxDelayTimes[i]) {
          delayTypeSet.add('random');
        } else {
          delayTypeSet.add('fixed');
        }
      }

      let delayType: 'no' | 'null' | 'fixed' | 'random' | undefined = 'null';
      let delayTypeList = Array.from(delayTypeSet);
      delayTypeList = delayTypeList.filter((x) => x);

      if (delayTypeList.length === 1) {
        delayType = delayTypeList[0] as any;
      } else {
        delayType = 'null';
      }

      const commentCount: any = {};
      (init ? newData.slice(1) : newData)?.forEach((item) => {
        if (item.updatedValues?.commentFiltersList && item.updatedValues?.commentFiltersList?.length > 0) {
          item.updatedValues?.commentFiltersList?.forEach((comment) => {
            commentCount[comment?.value || ''] = (commentCount[comment?.value || ''] || 0) + 1;
          });
        } else {
          item.slaveData?.commentFiltersList?.forEach((comment) => {
            commentCount[comment?.value || ''] = (commentCount[comment?.value || ''] || 0) + 1;
          });
        }
      });

      const commonComments = Object.keys(commentCount)?.filter(
        (comment) => commentCount[comment] === (init ? newData.slice(1) : newData).length && commentCount
      );
      const commonCommentValues: StringValue.AsObject[] | undefined =
        commonComments && commonComments.length > 0
          ? commonComments?.map((x) => {
              return { value: x || '' };
            })
          : undefined;

      const magicCount: any = {};
      (init ? newData.slice(1) : newData)?.forEach((item) => {
        if (item.updatedValues?.magicFiltersList && item.updatedValues?.magicFiltersList?.length > 0) {
          item.updatedValues?.magicFiltersList?.forEach((magic) => {
            magicCount[magic?.value || ''] = (magicCount[magic?.value || ''] || 0) + 1;
          });
        } else {
          item.slaveData?.magicFiltersList?.forEach((magic) => {
            magicCount[magic?.value || ''] = (magicCount[magic?.value || ''] || 0) + 1;
          });
        }
      });

      const commonMagics = Object.keys(magicCount)?.filter(
        (magic) => magicCount[magic] === (init ? newData.slice(1) : newData).length && magicCount
      );
      const commonMagicsValues: Int64Value.AsObject[] | undefined =
        commonMagics && commonMagics.length > 0
          ? commonMagics.map((x) => {
              return { value: +x || 0 };
            })
          : undefined;

      const platformSet = new Set();
      newData.forEach((x) => {
        const platform = x.slaveData?.platform;
        if (platform) platformSet.add(platform);
      });

      const platforms = Array.from(platformSet);
      let placedTypeOptions: {
        name: string;
        value: string;
      }[] = [];
      if (platforms.length === 1) {
        placedTypeOptions = platforms[0] === 'MT-4' ? mt4Options : platforms[0] === 'MT-5' ? mt5Options : [];
      }

      // const customPlacedTypes = (init ? newData.slice(1) : newData).map((x) => {
      //   const updated = x.updatedValues;
      //   const old = x.slaveData;
      //   return updated?.placedType?.value
      //     ? updated?.placedType?.value === 'no'
      //       ? ''
      //       : updated?.placedType?.value
      //     : old?.placedType?.value
      //     ? old?.placedType?.value
      //     : '';
      // });
      // const customPlacedTypesSame = customPlacedTypes.every((value, index, array) => value === array[0]);
      // const customPlacedType = customPlacedTypesSame ? { value: customPlacedTypes[0] || '' } : undefined;

      const copyCmnts = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.copyComment?.value ?? old?.copyComment?.value;
      });

      const customCmnts = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.customComment?.value ?? (old?.customComment?.value || '');
      });

      const copyCmntSet = new Set();
      for (let i = 0; i < copyCmnts.length; i++) {
        if (copyCmnts[i] && customCmnts[i]) {
          copyCmntSet.add('Custom');
        } else if (copyCmnts[i] && customCmnts[i] === '') {
          copyCmntSet.add('Yes');
        } else if (!copyCmnts[i]) {
          copyCmntSet.add('No');
        }
      }

      let copyCmnt = { value: false };
      let customCmnt: StringValue.AsObject | undefined = undefined;
      let slaveCopyCmnt = 'null';
      let copyCmntsList = Array.from(copyCmntSet);
      if (firstItem.copyComment) {
        slaveCopyCmnt = firstItem.copyComment;
        if (firstItem.copyComment === 'Custom') {
          copyCmnt = { value: true };
          customCmnt = { value: customCmnts[0] || '' };
        }
      } else if (copyCmntsList.length === 1) {
        slaveCopyCmnt = copyCmntsList[0] as any;
        if (slaveCopyCmnt === 'Custom') {
          copyCmnt = { value: true };
          customCmnt = { value: customCmnts[0] || '' };
        } else if (slaveCopyCmnt === 'Yes') {
          copyCmnt = { value: true };
        }
      }

      const copyMagics = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.copyMagicNumber?.value ?? old?.copyMagicNumber?.value;
      });

      const magicVals = (init ? newData.slice(1) : newData).map((x) => {
        const updated = x.updatedValues;
        const old = x.slaveData;
        return updated?.magicNumber?.value ?? (old?.magicNumber?.value || 0);
      });

      const copyMagicSet = new Set();
      for (let i = 0; i < copyMagics.length; i++) {
        if (copyMagics[i] && magicVals[i]) {
          copyMagicSet.add('Custom');
        } else if (copyMagics[i] && +magicVals[i] === 0) {
          copyMagicSet.add('Yes');
        } else if (!copyMagics[i]) {
          copyMagicSet.add('No');
        }
      }

      let copyMagic = { value: false };
      let magicVal: Int64Value.AsObject | undefined = undefined;
      let slaveCopyMagic = 'null';
      let copyMagicList = Array.from(copyMagicSet);
      if (firstItem.copyMagic) {
        slaveCopyMagic = firstItem.copyMagic;
        if (firstItem.copyMagic === 'Custom') {
          copyMagic = { value: true };
          magicVal = { value: +magicVals[0] || 0 };
        }
      } else if (copyMagicList.length === 1) {
        slaveCopyMagic = copyMagicList[0] as any;
        if (slaveCopyMagic === 'Custom') {
          copyMagic = { value: true };
          magicVal = { value: +magicVals[0] || 0 };
        } else if (slaveCopyMagic === 'Yes') {
          copyMagic = { value: true };
        }
      }

      // Update the first item with new values
      let updatedFirstItem: CopyTradingTableDto = {
        ...firstItem,
        updatedValues: {
          ...(firstItem.updatedValues as Slave.AsObject),
          copyStopLoss: { value: copySL },
          copyTakeProfit: { value: copyTP },
          copyPendingOrders: { value: copyPendingOrders },
          riskType: { value: allRiskTypesSame ? riskTypeMapFromValue[riskTypeValues[0]] : '' },
          lotMultiplierValue: lotMultiplierValue,
          fixedLotValue: fixedLotValue,
          balanceMultiplierValue: balanceMultiplierValue,
          balancePercentageValue: balancePercentageValue,
          fixedBalanceMultiplierValue: fixedBalanceMultiplierValue,
          fixedMasterBalance: fixedMasterBalance,
          stopLossPip: stopLossPip,
          takeProfitPip: takeProfitPip,
          slRefiner: slRefiner,
          tpRefiner: tpRefiner,
          forceMinimumLotSize: { value: forceMinimumLotSize },
          forceMaximumLotSize: { value: forceMaximumLotSize },
          reverseTrade: { value: reverseTrade },
          strictClose: { value: strictClose },
          considerContractSize: { value: considerContractSize },
          copyExpiryTime: { value: copyExpiryTime },
          minLotFilter: minLotFilter,
          maxLotFilter: maxLotFilter,
          lotRefinerValue: lotRefinerValue,
          minDelayTime: minDelayTime,
          maxDelayTime: maxDelayTime,
          // placedType: customPlacedType,
          copyComment: copyCmnt,
          customComment: customCmnt as any,
          copyMagicNumber: copyMagic,
          magicNumber: magicVal as any
        },
        placedTypeOptions: placedTypeOptions,
        copyComment: slaveCopyCmnt,
        copyMagic: slaveCopyMagic,
        delayType: delayType
      };

      if (commonCommentValues && updatedFirstItem.updatedValues) {
        updatedFirstItem.updatedValues.commentFiltersList = commonCommentValues;
      }

      if (commonMagicsValues && updatedFirstItem.updatedValues) {
        updatedFirstItem.updatedValues.magicFiltersList = commonMagicsValues;
      }

      console.log('UPDATED INIT DATA', init, updatedFirstItem);

      // Set the updated data state
      if (JSON.stringify(updatedFirstItem.updatedValues) !== JSON.stringify(firstItem.updatedValues)) {
        setData([updatedFirstItem, ...newData.slice(1)]);
      }
    }
  };

  const handleSubmit = async () => {
    const allConfig: UpdatedSlaveConfig.AsObject[] = [];
    for (const slave of data) {
      const req = prepareSingleUpdateReq(slave);
      if (req && req !== 'error') {
        allConfig.push(req);
      }
      if (req === 'error') {
        return;
      }
    }

    if (allConfig.length <= 0) {
      showError('Nothing to update');
      return;
    }

    try {
      if (user && user?.tcId) {
        const req: UpdateSlaveManyReq.AsObject = {
          userId: user?.tcId || '',
          configId: selectedMaster.configId,
          updatedSlaveConfigsList: allConfig || []
        };
        const cl = await tradeClient();
        const response = await cl.updateSlaveMany(req);
        sendCrispEvent(req, cl);
        console.log('RESPONSE =======>  ', response);
        service.dispatchSnackbar(dispatch, 'Slaves updated successfully', 'alert', 'success', 5000);
        handleSuccess();
      }
    } catch (err: any) {
      console.log('ERROR: ', err);
      service.dispatchSnackbar(dispatch, err.message, 'alert', 'error', 5000);
    }
  };

  const sendCrispEvent = (updateSlaveReq: UpdateSlaveManyReq.AsObject, client: TradeClient) => {
    for (const req of updateSlaveReq.updatedSlaveConfigsList) {
      const updateReq = {
        ...req,
        slaveId: req.id,
        configId: updateSlaveReq.configId,
        userId: updateSlaveReq.userId
      } as UpdateSlaveReq.AsObject;
      const slaveAccount = data.find((x) => x.id === req.id);
      const crispData = client.flattenUpdateSlaveReq(updateReq, slaveAccount?.accountId, selectedMaster.accountId);
      console.log('crispData: Multiple Slave Config Modified -', crispData);
      const entries = Object.entries(crispData);
      for (let i = 0; i < entries.length; i += 8) {
        const chunk = Object.fromEntries(entries.slice(i, i + 8));
        chunk.slaveId = crispData.slaveId;
        console.log(`crispData: Multiple Slave Config Modified - part ${i / 8 + 1}`, chunk);
        Crisp.session.pushEvent(`Multiple Slave Config Modified - part ${i / 8 + 1}`, chunk, 'green' as any);
      }
    }
  };

  const prepareSingleUpdateReq = (slave: CopyTradingTableDto): UpdatedSlaveConfig.AsObject | null | 'error' => {
    if (slave?.updatedValues && slave?.slaveData) {
      return validateRequest(slave?.updatedValues, slave?.slaveData, slave);
    }
    return null;
  };

  const validateRequest = (
    updated: Slave.AsObject,
    old: Slave.AsObject,
    slave: CopyTradingTableDto
  ): UpdatedSlaveConfig.AsObject | null | 'error' => {
    const riskType = updated.riskType?.value ? riskTypeMapFromKey[updated.riskType?.value] : riskTypeMapFromKey[old.riskType?.value || ''];
    console.log('validateRequest ========>', updated, old);

    const req: UpdatedSlaveConfig.AsObject = {
      id: slave.id,
      riskType: riskType,
      commentFiltersList: updated.commentFiltersList ?? old.commentFiltersList,
      magicFiltersList: updated.magicFiltersList ?? old.magicFiltersList,
      manageExisting: old.manageExisting,
      enable: old.enabled,
      allowedTradeSide: old.allowedTradeSide,
      tradingHoursList: old.tradingHoursList,
      magicFilterType: filter_type_map_value[old?.magicFilterType?.value || 'UNKNOWN'],
      commentFilterType: filter_type_map_value[old?.commentFilterType?.value || 'UNKNOWN'],
    };

    req.lotMultiplierValue = {
      value:
        riskType === RISK_TYPE.LOT_MULTIPLIER &&
        updated.lotMultiplierValue?.value !== undefined &&
        (updated.lotMultiplierValue?.value || +updated.lotMultiplierValue?.value === 0)
          ? updated.lotMultiplierValue?.value
          : riskType === RISK_TYPE.LOT_MULTIPLIER && old.lotMultiplierValue?.value
          ? old.lotMultiplierValue?.value
          : 0
    };

    req.fixedLotValue = {
      value:
        riskType === RISK_TYPE.FIXED_LOT &&
        updated.fixedLotValue?.value !== undefined &&
        (updated.fixedLotValue?.value || +updated.fixedLotValue?.value === 0)
          ? updated.fixedLotValue?.value || 0
          : riskType === RISK_TYPE.FIXED_LOT && old.fixedLotValue?.value
          ? old.fixedLotValue?.value
          : 0
    };

    req.balanceMultiplierValue = {
      value:
        riskType === RISK_TYPE.BALANCE_MULTIPLIER &&
        updated.balanceMultiplierValue?.value !== undefined &&
        (updated.balanceMultiplierValue?.value || +updated.balanceMultiplierValue?.value === 0)
          ? updated.balanceMultiplierValue?.value
          : riskType === RISK_TYPE.BALANCE_MULTIPLIER && old.balanceMultiplierValue?.value
          ? old.balanceMultiplierValue?.value
          : 0
    };

    req.balancePercentageValue = {
      value:
        riskType === RISK_TYPE.BALANCE_PERCENTAGE &&
        updated.balancePercentageValue?.value !== undefined &&
        (updated.balancePercentageValue?.value || +updated.balancePercentageValue?.value === 0)
          ? updated.balancePercentageValue?.value
          : riskType === RISK_TYPE.BALANCE_PERCENTAGE && old.balancePercentageValue?.value
          ? old.balancePercentageValue?.value
          : 0
    };

    if (riskType === RISK_TYPE.FIXED_BALANCE_MULTIPLIER) {
      req.fixedBalanceMultiplierValue = {
        value:
          updated.fixedBalanceMultiplierValue?.value !== undefined &&
          (updated.fixedBalanceMultiplierValue?.value || +updated.fixedBalanceMultiplierValue?.value === 0)
            ? updated.fixedBalanceMultiplierValue?.value || 0
            : old.fixedBalanceMultiplierValue?.value
            ? old.fixedBalanceMultiplierValue?.value
            : 0
      };

      req.fixedMasterBalance = {
        value:
          updated.fixedMasterBalance?.value !== undefined && (updated.fixedMasterBalance?.value || +updated.fixedMasterBalance?.value === 0)
            ? updated.fixedMasterBalance?.value
            : old.fixedMasterBalance?.value
            ? old.fixedMasterBalance?.value
            : 0
      };
    }

    if (riskType === RISK_TYPE.LOT_MULTIPLIER && req.lotMultiplierValue?.value <= 0) {
      showError('Invalid lot multiplier for account ' + slave.accountName);
      return 'error';
    }
    if (riskType === RISK_TYPE.BALANCE_MULTIPLIER && req.balanceMultiplierValue?.value <= 0) {
      showError('Invalid balance multiplier for account ' + slave.accountName);
      return 'error';
    }
    if (riskType === RISK_TYPE.FIXED_LOT && req.fixedLotValue?.value <= 0) {
      showError('Invalid fixed lot for account ' + slave.accountName);
      return 'error';
    }
    if (riskType === RISK_TYPE.BALANCE_PERCENTAGE && (req.balancePercentageValue?.value <= 0 || req.balancePercentageValue?.value > 100)) {
      showError('Invalid balance percentage for account ' + slave.accountName);
      return 'error';
    }
    if (
      riskType === RISK_TYPE.FIXED_BALANCE_MULTIPLIER &&
      (!req.fixedBalanceMultiplierValue || req.fixedBalanceMultiplierValue?.value <= 0)
    ) {
      showError('Invalid fixed balance multiplier for account ' + slave.accountName);
      return 'error';
    }
    if (riskType === RISK_TYPE.FIXED_BALANCE_MULTIPLIER && (!req.fixedMasterBalance || req.fixedMasterBalance?.value <= 0)) {
      showError('Invalid fixed master balance for account ' + slave.accountName);
      return 'error';
    }

    req.copyTakeProfit = {
      value: updated.copyTakeProfit?.value !== undefined ? updated.copyTakeProfit.value : old.copyTakeProfit?.value || false
    };
    req.copyStopLoss = {
      value: updated.copyStopLoss?.value !== undefined ? updated.copyStopLoss.value : old.copyStopLoss?.value || false
    };
    req.copyPendingOrders = {
      value: updated.copyPendingOrders?.value !== undefined ? updated.copyPendingOrders.value : old.copyPendingOrders?.value || false
    };
    req.forceMinimumLotSize = {
      value: updated.forceMinimumLotSize?.value !== undefined ? updated.forceMinimumLotSize.value : old.forceMinimumLotSize?.value || false
    };
    req.forceMaximumLotSize = {
      value: updated.forceMaximumLotSize?.value !== undefined ? updated.forceMaximumLotSize.value : old.forceMaximumLotSize?.value || false
    };
    req.reverseTrade = {
      value: updated.reverseTrade?.value !== undefined ? updated.reverseTrade.value : old.reverseTrade?.value || false
    };
    req.strictClose = {
      value: updated.strictClose?.value !== undefined ? updated.strictClose.value : old.strictClose?.value || false
    };
    req.considerContractSize = {
      value:
        updated.considerContractSize?.value !== undefined ? updated.considerContractSize.value : old.considerContractSize?.value || false
    };
    req.copyExpiryTime = {
      value: updated.copyExpiryTime?.value !== undefined ? updated.copyExpiryTime.value : old.copyExpiryTime?.value || false
    };

    // TODO: check platform
    req.copyComment = {
      value: updated.copyComment?.value !== undefined ? updated.copyComment.value : old.copyComment?.value || false
    };
    req.customComment = {
      value: !req.copyComment
        ? ''
        : updated.customComment?.value || updated.customComment?.value === '' || updated.customComment?.value === null
        ? updated.customComment.value
        : old.customComment?.value || ''
    };

    // // TODO: check platform
    // req.customPlacedType = {
    //   value:
    //     updated.placedType?.value && updated.placedType.value === 'no'
    //       ? ''
    //       : updated.placedType?.value
    //       ? updated.placedType?.value
    //       : old?.placedType?.value || ''
    // };

    req.copyMagicNumber = {
      value: updated.copyMagicNumber?.value !== undefined ? updated.copyMagicNumber.value : old.copyMagicNumber?.value || false
    };
    req.magicNumber = {
      value: !req.copyMagicNumber
        ? 0
        : updated.magicNumber?.value !== undefined &&
          (updated.magicNumber?.value || +updated.magicNumber?.value === 0 || updated.magicNumber?.value === null)
        ? updated.magicNumber.value || 0
        : old.magicNumber?.value || 0
    };

    req.lotRefinerValue = {
      value:
        updated.lotRefinerValue?.value || updated.lotRefinerValue?.value === 0
          ? updated.lotRefinerValue.value || 0
          : old.lotRefinerValue?.value || 0
    };

    req.minDelayTime = {
      value:
        updated.minDelayTime?.value !== undefined &&
        (updated.minDelayTime?.value || +updated?.minDelayTime?.value === 0 || updated.minDelayTime?.value === null)
          ? updated.minDelayTime.value || 0
          : old.minDelayTime?.value || 0
    };
    console.log('============> minDelayTime ', req.minDelayTime, '  ---  ', updated.minDelayTime, '  ---  ', old.minDelayTime?.value);

    req.maxDelayTime = {
      value:
        updated.maxDelayTime?.value !== undefined &&
        (updated.maxDelayTime?.value || +updated.maxDelayTime?.value === 0 || updated.maxDelayTime?.value === null)
          ? updated.maxDelayTime.value || 0
          : old.maxDelayTime?.value || 0
    };
    console.log('============> maxDelayTime ', req.maxDelayTime, '  ---  ', updated.maxDelayTime, '  ---  ', old.maxDelayTime?.value);

    req.minLotFilter = {
      value:
        updated.minLotFilter?.value || updated.minLotFilter?.value === 0 || updated.minLotFilter?.value === null
          ? updated.minLotFilter.value || 0
          : old.minLotFilter?.value || 0
    };
    req.maxLotFilter = {
      value:
        updated.maxLotFilter?.value || updated.maxLotFilter?.value === 0 || updated.maxLotFilter?.value === null
          ? updated.maxLotFilter.value || 0
          : old.maxLotFilter?.value || 0
    };

    req.stopLossPip = {
      value:
        req.copyStopLoss.value && !req.strictClose.value
          ? 0
          : updated.stopLossPip?.value || updated.stopLossPip?.value === 0
          ? updated.stopLossPip?.value || 0
          : old?.stopLossPip?.value || 0
    };
    req.takeProfitPip = {
      value:
        req.copyTakeProfit.value && !req.strictClose.value
          ? 0
          : updated.takeProfitPip?.value || updated.takeProfitPip?.value === 0
          ? updated.takeProfitPip?.value || 0
          : old?.takeProfitPip?.value || 0
    };
    req.slRefiner = {
      value: !req.copyStopLoss.value
        ? 0
        : updated.slRefiner?.value || updated.slRefiner?.value === 0
        ? updated.slRefiner?.value || 0
        : old?.slRefiner?.value || 0
    };
    req.tpRefiner = {
      value: !req.copyTakeProfit.value
        ? 0
        : updated.tpRefiner?.value || updated.tpRefiner?.value === 0
        ? updated.tpRefiner?.value || 0
        : old?.tpRefiner?.value || 0
    };

    if (req.minDelayTime.value > req.maxDelayTime.value) {
      showError('Minimum delay must be greater or equal to maximum delay for account ' + slave.accountName);
      return 'error';
    }

    if (req.minDelayTime.value <= 0 && req.maxDelayTime.value > 0) {
      showError('Minimum delay must be positive for random trade delay for account ' + slave.accountName);
      return 'error';
    }

    if (
      slave.delayType &&
      (slave.delayType === 'fixed' || slave.delayType === 'random') &&
      req.minDelayTime.value <= 0 &&
      req.maxDelayTime.value <= 0
    ) {
      showError(`Delay time must be positive for ${slave.delayType} trade delay for account ` + slave.accountName);
      return 'error';
    }

    if (req.minLotFilter.value > req.maxLotFilter.value) {
      showError('Minimum filter lot must be greater or equal to maximum filter lot for account ' + slave.accountName);
      return 'error';
    }

    console.log(slave.accountName + ' ======> riskType: ', riskType, req);

    return req;
  };

  const showError = (message: string) => {
    service.dispatchSnackbar(dispatch, message, 'alert', 'error', 5000);
  };

  const getHeader = (title: string, tooltip: string) => {
    return (
      <>
        <Tooltip
          title={
            <Typography
              color={theme.palette.mode === 'dark' ? theme.palette.background.paper : theme.typography.caption.color}
              variant={'caption'}
            >
              {tooltip}
            </Typography>
          }
        >
          <Typography variant={'inherit'}>{title}</Typography>
        </Tooltip>
      </>
    );
  };

  const updateData = (rowIndex: number, columnId: string, value: any, otherObj?: boolean) => {
    if (rowIndex === 0) {
      setData((old: any[]) => {
        return old.map((row, index) => {
          if (otherObj) {
            return {
              ...row,
              [columnId]: value
            };
          }
          return {
            ...row,
            updatedValues: {
              ...row.updatedValues,
              [columnId]: value
            }
          };
        });
      });
    }
    setData((old: any[]) => {
      return old.map((row, index) => {
        if (index === rowIndex) {
          if (otherObj) {
            return {
              ...(old[rowIndex] as CopyTradingTableDto),
              [columnId]: value
            };
          }
          return {
            ...(old[rowIndex] as CopyTradingTableDto),
            updatedValues: {
              ...old[rowIndex].updatedValues,
              [columnId]: value
            }
          };
        }
        return row;
      });
    });
  };

  const columns = [
    {
      Header: () => getHeader('Slave', 'Slave trading account'),
      accessor: 'accountName',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Risk Type', 'Risk type for each slave'),
      accessor: 'riskType',
      dataType: 'riskType',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Risk Settings', 'Risk setting to be used on your slave'),
      accessor: 'riskSettings',
      dataType: 'riskSettings',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Copy SL', 'Copy Stop Loss from the master to slave'),
      accessor: 'copySL',
      dataType: 'copySL',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Copy TP', 'Copy Take Profit from the master to slave'),
      accessor: 'copyTP',
      dataType: 'copyTP',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Copy PO', 'Copy Pending Orders from the master to the slave'),
      accessor: 'copyPO',
      dataType: 'copyPO',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: 'Fixed SL (pips)',
      accessor: 'fixedSL',
      dataType: 'fixedSL',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Fixed TP (Pips)', 'Set a fixed Take Profit in pips on each slave trade, ignoring the master take profit'),
      accessor: 'fixedSP',
      dataType: 'fixedTP',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('SL Refinement (pips)', 'Refine the masters Stop Loss in pips'),
      accessor: 'slRefinement',
      dataType: 'slRefinement',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('TP Refinement (pips)', 'Refine the masters Take Profit in pips'),
      accessor: 'tpRefinement',
      dataType: 'tpRefinement',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Force Minimum Lot', 'Force the brokers minimum lot size if the position calculates below the minimum'),
      accessor: 'forceMinimumLotSize',
      dataType: 'forceMinimumLotSize',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Force Maximum Lot', 'Force the brokers maximum lot size if the position calculates above the maximum'),
      accessor: 'forceMaximumLotSize',
      dataType: 'forceMaximumLotSize',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Reverse Trade', 'Place trades in the opposite direction to the master, E.G a Buy copies as a Sell'),
      accessor: 'reverseTrade',
      dataType: 'reverseTrade',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Contract Alignment', 'Consider broker contract sizing'),
      accessor: 'contractAllignment',
      dataType: 'contractAllignment',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Copy Expiry', 'Copy expiration time on pending orders'),
      accessor: 'copyExpiry',
      dataType: 'copyExpiry',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Strict Close', 'Ignore trade close signals from the master position'),
      accessor: 'strictClose',
      dataType: 'strictClose',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Copy Comment', 'Copy trade comments from the master position, or set a custom comment'),
      accessor: 'copyComment',
      dataType: 'copyComment',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Custom Comment', 'Set a custom comment on your slave trades'),
      accessor: 'customComment',
      dataType: 'customComment',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Copy Magic', 'Copy the masters magic number or pass a custom magic number'),
      accessor: 'copyMagic',
      dataType: 'copyMagic',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Custom Magic', 'Set a custom magic number on each slave position'),
      accessor: 'customMagic',
      dataType: 'customMagic',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Delay Type', 'Set a trade delay, adding time between the master and slave positions'),
      accessor: 'delayType',
      dataType: 'delayType',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Trade Delay', 'The trade delay value in milliseconds'),
      accessor: 'tradeDelay',
      dataType: 'tradeDelay',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    // {
    //   Header: () => getHeader('Custom Placed Type', 'Set the placed type of a position (only available on certain platforms)'),
    //   accessor: 'customPlacedType',
    //   dataType: 'customPlacedType',
    //   Cell: (params: any) => RowEdit({ ...params, updateData })
    // },
    {
      Header: () => getHeader('Lot Refiner', 'Refine your trades lot size by the set value (can be positive or negative)'),
      accessor: 'lotRefiner',
      dataType: 'lotRefiner',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Magic Filters', 'Filter trades by magic number, only copying trades where the magic number matches'),
      accessor: 'magicFilters',
      dataType: 'magicFilters',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Comment Filters', 'Filter trades by comment, only copying trades where the comment matches'),
      accessor: 'commentFilters',
      dataType: 'commentFilters',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    },
    {
      Header: () => getHeader('Lot Filter', 'Only copy trades where the master lot size is between the desired range (min : max)'),
      accessor: 'lotFilter',
      dataType: 'lotFilter',
      Cell: (params: any) => RowEdit({ ...params, updateData })
    }
  ];

  return (
    <>
      <MainCard
        className="editAllSlave"
        title={
          <Typography fontWeight={700} fontSize={18} color="textPrimary">
            Edit selected slaves
          </Typography>
        }
        secondary={
          <IconButton size="small" onClick={handleClose}>
            <CloseOutlined />
          </IconButton>
        }
        sx={{
          border: 'none',
          boxShadow: 'none',
          '& .MuiCardHeader-root': {
            pb: 2
          }
        }}
      >
        <Grid item xs={12} sx={{ minHeight: 350, maxHeight: '75vh', overflowY: 'auto', overflowX: 'hidden' }}>
          <Grid
            sx={{
              position: 'relative',
              borderRadius: 2,
              backgroundColor: theme.palette.background.paper
            }}
          >
            <Grid
              sx={{
                overflow: 'auto',
                position: 'relative',
                width: '100%',
                maxWidth: '88vw',
                '::-webkit-scrollbar': {
                  height: 8,
                  width: 8
                },
                '::-webkit-scrollbar-track': {
                  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[100],
                  borderRadius: 4
                },
                '::-webkit-scrollbar-thumb': {
                  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[600] : theme.palette.grey[300],
                  borderRadius: 4,
                  '&:hover': {
                    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[500] : theme.palette.grey[400]
                  }
                }
              }}
            >
              <EditableTable columns={columns} data={data} />
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            sx={{
              mt: 3,
              pt: 3,
              borderTop: `1px solid ${theme.palette.divider}`
            }}
            container
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'flex-end'}
            alignItems="center"
            gap={1.5}
          >
            <Button 
              sx={{ 
                paddingX: '24px',
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 500
              }} 
              onClick={handleClose} 
              disableElevation 
              variant="outlined" 
              color="secondary"
            >
              Cancel
            </Button>
            <LoadingButton
              sx={{ 
                paddingX: '24px',
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 500
              }}
              loadingPosition="end"
              endIcon={<></>}
              disableElevation
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => {
                handleSubmit();
              }}
            >
              Confirm
            </LoadingButton>
          </Grid>
        </Grid>
      </MainCard>
    </>
  );
};

interface EditableRowProps {
  value: any;
  row: Row;
  column: any;
  updateData: (index: number, id: string, value: string, otherObj?: boolean) => void;
  editableRowIndex: number;
}

export const RowEdit = ({ value: initialValue, row: { index, original }, column: { id, dataType }, updateData }: EditableRowProps) => {
  const [value, setValue] = useState(initialValue);
  const theme = useTheme();

  const onChange = (e: any) => {
    setValue(e.target.value);
    updateData(index, id, e.target.value);
  };

  const onBlur = () => {
    // updateData(index, id, value);
  };

  const onFieldValue = (name: string, value: any, otherObj: boolean = false) => {
    updateData(index, name, value, otherObj);
  };

  let element;
  let userInfoSchema;

  let IsEditAble = true; // index === editableRowIndex;

  switch (dataType) {
    case 'riskType':
      element = RiskTypeElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'riskSettings':
      element = RiskSettingsElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'copySL':
      element = CopySLElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'copyTP':
      element = CopyTPElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'copyPO':
      element = CopyPOElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'fixedSL':
      element = FixedSLElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'fixedTP':
      element = FixedTPElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'slRefinement':
      element = SLRefinementElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'tpRefinement':
      element = TPRefinementElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'forceMinimumLotSize':
      element = ForceMinimumLotElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'forceMaximumLotSize':
      element = ForceMaximumLotElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'reverseTrade':
      element = ReverseTradeElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'contractAllignment':
      element = ContractAllignmentElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'copyExpiry':
      element = CopyExpiryElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'strictClose':
      element = StrictCloseElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'copyComment':
      element = CopyCommentSelectorElement(index, original as any, onBlur, onChange, onFieldValue);
      break;
    case 'customComment':
      element = CopyCustomCommentElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'copyMagic':
      element = CopyMagicNumberElement(index, original as any, onBlur, onChange, onFieldValue);
      break;
    case 'customMagic':
      element = CustomMagicNumberElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'delayType':
      element = DelayTypeElement(index, original as any, onBlur, onChange, onFieldValue);
      break;
    case 'tradeDelay':
      element = TradeDelayElement(original as any, onBlur, onChange, onFieldValue);
      break;
    // case 'customPlacedType':
    //   element = CustomPlacedTypeElement(index, original as any, onBlur, onChange, onFieldValue);
    //   break;
    case 'lotRefiner':
      element = LotRefinerElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'magicFilters':
      element = MagicFiltersElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'commentFilters':
      element = CommentFiltersElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'lotFilter':
      element = LotFilterElement(original as any, onBlur, onChange, onFieldValue);
      break;
    case 'text':
      element = (
        <>
          {IsEditAble ? (
            <>
              <Formik
                initialValues={{
                  userInfo: value
                }}
                enableReinitialize
                validationSchema={userInfoSchema}
                onSubmit={() => {}}
              >
                {({ values, handleChange, handleBlur, errors, touched }) => (
                  <Form>
                    <TextField
                      value={values.userInfo}
                      id={`${index}-${id}`}
                      name="userInfo"
                      onChange={(e) => {
                        handleChange(e);
                        onChange(e);
                      }}
                      onBlur={handleBlur}
                      error={touched.userInfo && Boolean(errors.userInfo)}
                      helperText={touched.userInfo && errors.userInfo && (errors.userInfo as string)}
                      sx={{
                        '& .MuiOutlinedInput-input': {
                          py: 0.75,
                          px: 1,
                          backgroundColor: theme.palette.mode === 'light' ? 'common.white' : 'inherit'
                        }
                      }}
                    />
                  </Form>
                )}
              </Formik>
            </>
          ) : (
            value
          )}
        </>
      );
      break;
    default:
      element = <span style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>{value ? value : '-'}</span>;
      break;
  }

  return element;
};

const riskTypeMapFromDisplayText: any = {
  '': 0,
  'Fixed Lot': 1,
  'Lot Multiplier': 2,
  'Balance Multiplier': 3,
  'Fixed Balance Multiplier': 4,
  'Fixed % risk': 5
};

const riskTypeMapFromKey: any = {
  '': 0,
  FIXED_LOT: 1,
  LOT_MULTIPLIER: 2,
  BALANCE_MULTIPLIER: 3,
  FIXED_BALANCE_MULTIPLIER: 4,
  BALANCE_PERCENTAGE: 5
};

const riskTypeMapFromValue: any = {
  0: '',
  1: 'FIXED_LOT',
  2: 'LOT_MULTIPLIER',
  3: 'BALANCE_MULTIPLIER',
  4: 'FIXED_BALANCE_MULTIPLIER',
  5: 'BALANCE_PERCENTAGE'
};

const RiskTypeElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  return (
    <>
      <Formik
        initialValues={{
          riskType: selectedSlave?.updatedValues?.riskType?.value
            ? riskTypeMapFromKey[selectedSlave?.updatedValues?.riskType?.value]
            : selectedSlave?.riskType
            ? riskTypeMapFromDisplayText[selectedSlave?.riskType]
            : 0,
          riskSettings:
            selectedSlave?.riskType === 'Fixed Balance Multiplier'
              ? selectedSlave.slaveData?.fixedBalanceMultiplierValue?.value
              : Number(selectedSlave?.riskSetting?.slice(0, -1)),
          fixedMasterBalance: selectedSlave?.riskType === 'Fixed Balance Multiplier' ? selectedSlave.slaveData?.fixedMasterBalance?.value?.toString() : '',
          riskSettingsFixedLot: '',
          riskSettingsBalancePercentage: '',
          considerContractSize: selectedSlave.slaveData?.considerContractSize?.value
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors, touched, setFieldValue, resetForm }) => (
          <Select
            sx={{ width: 220, textAlign: 'center' }}
            labelId="risk-type"
            id="risk-type"
            name="riskType"
            placeholder="Risk Type"
            value={values.riskType}
            //   onBlur={handleBlur}
            onChange={(event, value) => {
              if (+event?.target?.value === RISK_TYPE.FIXED_BALANCE_MULTIPLIER || +event?.target?.value === RISK_TYPE.BALANCE_MULTIPLIER) {
                onFieldValue('considerContractSize', { value: true });
              } else {
                onFieldValue('considerContractSize', { value: false });
              }
              const val = event?.target?.value;
              const riskType =
                val === RISK_TYPE.FIXED_BALANCE_MULTIPLIER
                  ? 'FIXED_BALANCE_MULTIPLIER'
                  : val === RISK_TYPE.LOT_MULTIPLIER
                  ? 'LOT_MULTIPLIER'
                  : val === RISK_TYPE.BALANCE_MULTIPLIER
                  ? 'BALANCE_MULTIPLIER'
                  : val === RISK_TYPE.FIXED_LOT
                  ? 'FIXED_LOT'
                  : val === RISK_TYPE.BALANCE_PERCENTAGE
                  ? 'BALANCE_PERCENTAGE'
                  : 0;
              onFieldValue('riskType', { value: riskType });
              onFieldValue('fixedLotValue', { value: 0 });
              onFieldValue('lotMultiplierValue', { value: 0 });
              onFieldValue('balanceMultiplierValue', { value: 0 });
              onFieldValue('fixedMasterBalance', { value: 0 });
            }}
            error={Boolean(touched.riskType && errors.riskType)}
          >
            <MenuItem selected={true} value={0}>
              Select
            </MenuItem>
            <MenuItem value={RISK_TYPE.FIXED_LOT}>Fixed Lot</MenuItem>
            <MenuItem value={RISK_TYPE.LOT_MULTIPLIER}>Lot Multiplier</MenuItem>
            <MenuItem value={RISK_TYPE.BALANCE_MULTIPLIER}>Balance Multiplier</MenuItem>
            <MenuItem value={RISK_TYPE.FIXED_BALANCE_MULTIPLIER}>Fixed Balance Multiplier</MenuItem>
            <MenuItem value={RISK_TYPE.BALANCE_PERCENTAGE}>Fixed % risk</MenuItem>
          </Select>
        )}
      </Formik>
    </>
  );
};

const RiskSettingsElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  console.log(
    'RiskSettingsElement: ',
    selectedSlave?.updatedValues?.riskType?.value
      ? selectedSlave?.updatedValues?.fixedLotValue?.value
      : selectedSlave?.slaveData?.riskType
      ? selectedSlave?.slaveData?.fixedLotValue?.value
      : '',
    selectedSlave?.updatedValues?.fixedLotValue?.value,
    selectedSlave?.slaveData?.fixedLotValue?.value
  );
  return (
    <Formik
      initialValues={{
        riskType: selectedSlave?.updatedValues?.riskType?.value
          ? riskTypeMapFromKey[selectedSlave?.updatedValues?.riskType?.value]
          : selectedSlave?.riskType
          ? riskTypeMapFromDisplayText[selectedSlave?.riskType]
          : '',
        riskSettingsBalanceMultiplier:
          selectedSlave?.updatedValues?.balanceMultiplierValue?.value !== undefined
            ? selectedSlave?.updatedValues?.balanceMultiplierValue?.value
            : selectedSlave?.slaveData?.balanceMultiplierValue?.value !== undefined
            ? selectedSlave?.slaveData?.balanceMultiplierValue?.value
            : '',
        riskSettingsLotMultiplier:
          selectedSlave?.updatedValues?.lotMultiplierValue?.value !== undefined
            ? selectedSlave?.updatedValues?.lotMultiplierValue?.value
            : selectedSlave?.slaveData?.lotMultiplierValue?.value !== undefined
            ? selectedSlave?.slaveData?.lotMultiplierValue?.value
            : '',
        fixedMasterBalance:
          selectedSlave?.updatedValues?.fixedMasterBalance?.value !== undefined
            ? selectedSlave?.updatedValues?.fixedMasterBalance?.value
            : selectedSlave?.slaveData?.fixedMasterBalance?.value !== undefined
            ? selectedSlave?.slaveData?.fixedMasterBalance?.value
            : '',
        fixedBalanceMultiplierValue:
          selectedSlave?.updatedValues?.fixedBalanceMultiplierValue?.value !== undefined
            ? selectedSlave?.updatedValues?.fixedBalanceMultiplierValue?.value
            : selectedSlave?.slaveData?.fixedBalanceMultiplierValue?.value !== undefined
            ? selectedSlave?.slaveData?.fixedBalanceMultiplierValue?.value
            : '',
        riskSettingsFixedLot:
          selectedSlave?.updatedValues?.fixedLotValue?.value !== undefined
            ? selectedSlave?.updatedValues?.fixedLotValue?.value
            : selectedSlave?.slaveData?.fixedLotValue?.value !== undefined
            ? selectedSlave?.slaveData?.fixedLotValue?.value
            : '',
        riskSettingsBalancePercentage:
          selectedSlave?.updatedValues?.balancePercentageValue?.value !== undefined
            ? selectedSlave?.updatedValues?.balancePercentageValue?.value
            : selectedSlave?.slaveData?.balancePercentageValue?.value !== undefined
            ? selectedSlave?.slaveData?.balancePercentageValue?.value
            : ''
      }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={() => {}}
    >
      {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => (
        <>
          {values.riskType === '' && <span style={{ display: 'grid', textAlign: 'center', width: 160 }}>-</span>}
          {parseInt(values.riskType) === RISK_TYPE.FIXED_BALANCE_MULTIPLIER && (
            <Grid display={'flex'} sx={{ width: 160 }}>
              <Grid sx={{ mr: 2, width: 72 }} item xs={12}>
                <Stack spacing={1}>
                  <FormControl variant="outlined">
                    <OutlinedInput
                      fullWidth
                      error={Boolean(touched.fixedMasterBalance && errors.fixedMasterBalance)}
                      inputProps={{
                        style: {
                          minHeight: '14px',
                          lineHeight: '12px',
                          textAlign: 'center',
                          paddingRight: 0,
                          paddingLeft: 0
                        }
                      }}
                      id="fixedMasterBalance"
                      type="number"
                      placeholder="-"
                      value={values.fixedMasterBalance}
                      name="fixedMasterBalance"
                      onFocus={() => {
                        if (values.fixedMasterBalance === 0 || values.fixedMasterBalance === '0') {
                          setFieldValue('fixedMasterBalance', '');
                        }
                      }}
                      onBlur={() => {
                        onFieldValue('fixedMasterBalance', { value: values.fixedMasterBalance ? +values.fixedMasterBalance : 0 });
                      }}
                      onChange={(event) => {
                        setFieldValue('fixedMasterBalance', event.target.value);
                      }}
                      //   placeholder="Fixed Master Balance"
                      endAdornment={
                        <InputAdornment position="end" style={{ width: '0px', padding: '0 2px', marginLeft: '-10px' }}>
                          $
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  {touched.fixedMasterBalance && errors.fixedMasterBalance && (
                    <FormHelperText error id="helper-text-fixedMasterBalance">
                      {errors.fixedMasterBalance}
                    </FormHelperText>
                  )}
                </Stack>
              </Grid>
              <Grid item xs={12} sx={{ width: 72 }}>
                <Stack spacing={1}>
                  <FormControl variant="outlined">
                    <OutlinedInput
                      fullWidth
                      error={Boolean(touched.fixedBalanceMultiplierValue && errors.fixedBalanceMultiplierValue)}
                      inputProps={{
                        style: {
                          minHeight: '14px',
                          lineHeight: '12px',
                          textAlign: 'center',
                          paddingRight: 0,
                          paddingLeft: 0
                          // marginRight: '-24px'
                        }
                      }}
                      id="risk-settings"
                      type="number"
                      value={values.fixedBalanceMultiplierValue}
                      placeholder="-"
                      name="fixedBalanceMultiplierValue"
                      onFocus={() => {
                        if (values.fixedBalanceMultiplierValue === 0 || values.fixedBalanceMultiplierValue === '0') {
                          setFieldValue('fixedBalanceMultiplierValue', '');
                        }
                      }}
                      onBlur={() => {
                        onFieldValue('fixedBalanceMultiplierValue', {
                          value: values.fixedBalanceMultiplierValue ? +values.fixedBalanceMultiplierValue : 0
                        });
                      }}
                      onChange={(event) => {
                        setFieldValue('fixedBalanceMultiplierValue', event.target.value);
                      }}
                      //   onBlur={handleBlur}
                      //   onChange={(event) => {
                      //     onFieldValue('fixedBalanceMultiplierValue', { value: +event.target.value });
                      //   }}
                      //   placeholder="Risk Setting"
                      endAdornment={
                        <InputAdornment position="end" style={{ width: '0px', padding: '0 4px', marginLeft: '-10px' }}>
                          %
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                  {touched.fixedBalanceMultiplierValue && errors.fixedBalanceMultiplierValue && (
                    <FormHelperText error id="helper-text-risk-settings">
                      {errors.fixedBalanceMultiplierValue}
                    </FormHelperText>
                  )}
                </Stack>
              </Grid>
            </Grid>
          )}
          {parseInt(values.riskType) === RISK_TYPE.BALANCE_MULTIPLIER && (
            <Grid item xs={12} sx={{ width: 160 }}>
              <Stack spacing={1}>
                <FormControl variant="outlined">
                  <OutlinedInput
                    fullWidth
                    error={Boolean(touched.riskSettingsBalanceMultiplier && errors.riskSettingsBalanceMultiplier)}
                    inputProps={{
                      style: { minHeight: '14px', lineHeight: '12px', textAlign: 'center', paddingRight: 0, paddingLeft: 0 }
                    }}
                    id="riskSettingsBalanceMultiplier"
                    type="number"
                    value={values.riskSettingsBalanceMultiplier}
                    name="riskSettingsBalanceMultiplier"
                    placeholder="-"
                    onFocus={() => {
                      if (values.riskSettingsBalanceMultiplier === 0 || values.riskSettingsBalanceMultiplier === '0') {
                        setFieldValue('riskSettingsBalanceMultiplier', '');
                      }
                    }}
                    onBlur={() => {
                      onFieldValue('balanceMultiplierValue', {
                        value: values.riskSettingsBalanceMultiplier ? +values.riskSettingsBalanceMultiplier : 0
                      });
                    }}
                    onChange={(event) => {
                      setFieldValue('riskSettingsBalanceMultiplier', event.target.value);
                    }}
                    endAdornment={
                      <InputAdornment position="end" style={{ marginLeft: '-10px' }}>
                        %
                      </InputAdornment>
                    }
                  />
                </FormControl>
                {touched.riskSettingsBalanceMultiplier && errors.riskSettingsBalanceMultiplier && (
                  <FormHelperText error id="riskSettingsBalanceMultiplier">
                    {errors.riskSettingsBalanceMultiplier}
                  </FormHelperText>
                )}
              </Stack>
            </Grid>
          )}
          {parseInt(values.riskType) === RISK_TYPE.LOT_MULTIPLIER && (
            <Grid item xs={12} sx={{ width: 160 }}>
              <Stack spacing={1}>
                <FormControl variant="outlined">
                  <OutlinedInput
                    fullWidth
                    error={Boolean(touched.riskSettingsLotMultiplier && errors.riskSettingsLotMultiplier)}
                    inputProps={{
                      style: { minHeight: '14px', lineHeight: '12px', textAlign: 'center', paddingRight: 0, paddingLeft: 0 }
                    }}
                    id="riskSettingsLotMultiplier"
                    type="number"
                    value={values.riskSettingsLotMultiplier}
                    name="riskSettingsLotMultiplier"
                    placeholder="-"
                    onFocus={() => {
                      if (values.riskSettingsLotMultiplier === 0 || values.riskSettingsLotMultiplier === '0') {
                        setFieldValue('riskSettingsLotMultiplier', '');
                      }
                    }}
                    onBlur={() => {
                      onFieldValue('lotMultiplierValue', {
                        value: values.riskSettingsLotMultiplier ? +values.riskSettingsLotMultiplier : 0
                      });
                    }}
                    onChange={(event) => {
                      setFieldValue('riskSettingsLotMultiplier', event.target.value);
                    }}
                    endAdornment={
                      <InputAdornment position="end" style={{ marginLeft: '-10px' }}>
                        %
                      </InputAdornment>
                    }
                  />
                </FormControl>
                {touched.riskSettingsLotMultiplier && errors.riskSettingsLotMultiplier && (
                  <FormHelperText error id="helper-text-risk-settings">
                    {errors.riskSettingsLotMultiplier}
                  </FormHelperText>
                )}
              </Stack>
            </Grid>
          )}
          {parseInt(values.riskType) === RISK_TYPE.FIXED_LOT && (
            <Grid item xs={12} sx={{ width: 160 }}>
              <Stack spacing={1}>
                <FormControl variant="outlined">
                  <OutlinedInput
                    fullWidth
                    error={Boolean(touched.riskSettingsFixedLot && errors.riskSettingsFixedLot)}
                    // label={'Lot Size'}
                    inputProps={{
                      style: { minHeight: '14px', lineHeight: '12px', textAlign: 'center', paddingRight: 0, paddingLeft: 0 }
                    }}
                    placeholder="-"
                    id="risk-settings-fixed-lot"
                    type="number"
                    value={values.riskSettingsFixedLot}
                    name="riskSettingsFixedLot"
                    onFocus={() => {
                      if (values.riskSettingsFixedLot === 0 || values.riskSettingsFixedLot === '0') {
                        setFieldValue('riskSettingsFixedLot', '');
                      }
                    }}
                    onBlur={() => {
                      console.log('riskSettingsFixedLot: blur: ', values.riskSettingsFixedLot, +(values.riskSettingsFixedLot || ''));
                      onFieldValue('fixedLotValue', { value: values.riskSettingsFixedLot ? +values?.riskSettingsFixedLot : 0 });
                    }}
                    onChange={(event) => {
                      console.log('riskSettingsFixedLot: ', event.target.value);
                      setFieldValue('riskSettingsFixedLot', event.target.value);
                    }}
                    // placeholder="Lot Size"
                  />
                </FormControl>
                {touched.riskSettingsFixedLot && errors.riskSettingsFixedLot && (
                  <FormHelperText error id="helper-text-risk-settings-fixed-lot">
                    Lot size is required a valid number
                  </FormHelperText>
                )}
              </Stack>
            </Grid>
          )}
          {parseInt(values.riskType) === RISK_TYPE.BALANCE_PERCENTAGE && (
            <Grid item xs={12} sx={{ width: 160 }}>
              <Stack spacing={1}>
                <FormControl variant="outlined">
                  <OutlinedInput
                    fullWidth
                    error={Boolean(touched.riskSettingsBalancePercentage && errors.riskSettingsBalancePercentage)}
                    inputProps={{
                      style: { minHeight: '14px', lineHeight: '12px', textAlign: 'center', paddingRight: 0, paddingLeft: 0 }
                    }}
                    id="risk-settings-BALANCE_PERCENTAGE"
                    type="number"
                    value={values.riskSettingsBalancePercentage}
                    name="riskSettingsBalancePercentage"
                    onFocus={() => {
                      if (values.riskSettingsBalancePercentage === 0 || values.riskSettingsBalancePercentage === '0') {
                        setFieldValue('riskSettingsBalancePercentage', '');
                      }
                    }}
                    onBlur={() => {
                      onFieldValue('balancePercentageValue', {
                        value: values.riskSettingsBalancePercentage ? +values.riskSettingsBalancePercentage : 0
                      });
                    }}
                    placeholder="-"
                    onChange={(event) => {
                      setFieldValue('riskSettingsBalancePercentage', +event.target.value);
                    }}
                    // placeholder="Balance percentage"
                  />
                </FormControl>
                {touched.riskSettingsBalancePercentage && errors.riskSettingsBalancePercentage && (
                  <FormHelperText error id="helper-text-risk-settings-fixed-lot">
                    Balance percentage is required a valid number
                  </FormHelperText>
                )}
              </Stack>
            </Grid>
          )}
        </>
      )}
    </Formik>
  );
};

const CopySLElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const defaultRef = useRef();
  const resolvedRef = defaultRef as any;
  const validationSchema = Yup.object().shape({});
  return (
    <>
      <Formik
        initialValues={{
          copyStopLoss:
            selectedSlave?.updatedValues?.copyStopLoss?.value !== undefined
              ? !!selectedSlave?.updatedValues?.copyStopLoss?.value
              : selectedSlave?.slaveData?.copyStopLoss?.value !== undefined
              ? !!selectedSlave?.slaveData?.copyStopLoss?.value
              : false,
          reverseTrade:
            selectedSlave?.updatedValues?.reverseTrade?.value !== undefined
              ? !!selectedSlave?.updatedValues?.reverseTrade?.value
              : selectedSlave?.slaveData?.reverseTrade?.value !== undefined
              ? !!selectedSlave?.slaveData?.reverseTrade?.value
              : false,
          strictClose:
            selectedSlave?.updatedValues?.strictClose?.value !== undefined
              ? !!selectedSlave?.updatedValues?.strictClose?.value
              : selectedSlave?.slaveData?.strictClose?.value !== undefined
              ? !!selectedSlave?.slaveData?.strictClose?.value
              : false
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors, touched, setFieldValue, resetForm }) => (
          <FormControlLabel
            label={''}
            sx={{ margin: 'auto', display: 'grid' }}
            control={
              <Checkbox
                ref={resolvedRef}
                name="copyStopLoss"
                disabled={values?.strictClose}
                checked={values.copyStopLoss}
                onChange={(event, checked) => {
                  if (!checked) {
                    onFieldValue('slRefiner', { value: 0 });
                  } else {
                    onFieldValue('stopLossPip', { value: 0 });
                  }
                  onFieldValue('copyStopLoss', { value: !!checked });
                }}
              />
            }
          />
        )}
      </Formik>
    </>
  );
};

const CopyTPElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const defaultRef = useRef();
  const resolvedRef = defaultRef as any;
  const validationSchema = Yup.object().shape({});
  return (
    <>
      <Formik
        initialValues={{
          copyTakeProfit:
            selectedSlave?.updatedValues?.copyTakeProfit?.value !== undefined
              ? selectedSlave?.updatedValues?.copyTakeProfit?.value
              : selectedSlave?.slaveData?.copyTakeProfit?.value !== undefined
              ? selectedSlave?.slaveData?.copyTakeProfit?.value
              : false,
          reverseTrade:
            selectedSlave?.updatedValues?.reverseTrade?.value !== undefined
              ? selectedSlave?.updatedValues?.reverseTrade?.value
              : selectedSlave?.slaveData?.reverseTrade?.value !== undefined
              ? selectedSlave?.slaveData?.reverseTrade?.value
              : false,
          strictClose:
            selectedSlave?.updatedValues?.strictClose?.value !== undefined
              ? selectedSlave?.updatedValues?.strictClose?.value
              : selectedSlave?.slaveData?.strictClose?.value !== undefined
              ? selectedSlave?.slaveData?.strictClose?.value
              : false
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors, touched, setFieldValue, resetForm }) => (
          <FormControlLabel
            label={''}
            sx={{ margin: 'auto', display: 'grid' }}
            control={
              <Checkbox
                ref={resolvedRef}
                name="copyTakeProfit"
                disabled={values?.strictClose}
                checked={!!values.copyTakeProfit}
                onChange={(event, checked) => {
                  if (!checked) {
                    onFieldValue('tpRefiner', { value: 0 });
                  } else {
                    onFieldValue('takeProfitPip', { value: 0 });
                  }
                  onFieldValue('copyTakeProfit', { value: checked });
                }}
              />
            }
          />
        )}
      </Formik>
    </>
  );
};

const CopyPOElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  return (
    <>
      <Formik
        initialValues={{
          copyPendingOrders:
            selectedSlave?.updatedValues?.copyPendingOrders?.value !== undefined
              ? selectedSlave?.updatedValues?.copyPendingOrders?.value
              : selectedSlave?.slaveData?.copyPendingOrders?.value !== undefined
              ? selectedSlave?.slaveData?.copyPendingOrders?.value
              : false
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors, touched, setFieldValue, resetForm }) => (
          <Checkbox
            sx={{ margin: 'auto', display: 'grid' }}
            name="copyPendingOrders"
            checked={values.copyPendingOrders}
            onChange={(event, checked) => {
              onFieldValue('copyPendingOrders', { value: checked });
            }}
          />
        )}
      </Formik>
    </>
  );
};

const FixedSLElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  return (
    <Formik
      initialValues={{
        fixedStopLossValue:
          selectedSlave?.updatedValues?.stopLossPip?.value || selectedSlave?.updatedValues?.stopLossPip?.value === 0
            ? selectedSlave?.updatedValues?.stopLossPip?.value
            : selectedSlave?.slaveData?.stopLossPip?.value || selectedSlave?.slaveData?.stopLossPip?.value === 0
            ? selectedSlave?.slaveData?.stopLossPip?.value
            : '',
        copyStopLoss:
          selectedSlave?.updatedValues?.copyStopLoss?.value !== undefined
            ? !!selectedSlave?.updatedValues?.copyStopLoss?.value
            : selectedSlave?.slaveData?.copyStopLoss?.value
            ? !!selectedSlave?.slaveData?.copyStopLoss?.value
            : false,
        strictClose:
          selectedSlave?.updatedValues?.strictClose?.value !== undefined
            ? !!selectedSlave?.updatedValues?.strictClose?.value
            : !selectedSlave?.slaveData?.strictClose?.value
            ? !!selectedSlave?.slaveData?.strictClose?.value
            : false
      }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={() => {}}
    >
      {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => (
        <>
          {values.copyStopLoss && !values.strictClose && <span style={{ textAlign: 'center', display: 'grid' }}>-</span>}
          {!(values.copyStopLoss && !values.strictClose) && (
            <OutlinedInput
              sx={{ minWidth: 60 }}
              fullWidth
              error={Boolean(touched.fixedStopLossValue && errors.fixedStopLossValue)}
              // label={'Enter Fixed Stop Loss'}
              inputProps={{ style: { minHeight: '14px', lineHeight: '12px', textAlign: 'center' } }}
              id="fixedStopLossValue"
              type="number"
              value={values.fixedStopLossValue || ''}
              name="fixedStopLossValue"
              onChange={(event) => {
                setFieldValue('fixedStopLossValue', +event.target.value);
              }}
              onBlur={(event) => {
                onFieldValue('stopLossPip', { value: +values.fixedStopLossValue });
              }}
              placeholder="-"
              disabled={values.copyStopLoss && !values.strictClose}
              readOnly={values.copyStopLoss && !values.strictClose}
            />
          )}
        </>
      )}
    </Formik>
  );
};

const FixedTPElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  return (
    <Formik
      initialValues={{
        fixedTakeProfitValue:
          selectedSlave?.updatedValues?.takeProfitPip?.value || selectedSlave?.updatedValues?.takeProfitPip?.value === 0
            ? selectedSlave?.updatedValues?.takeProfitPip?.value
            : selectedSlave?.slaveData?.takeProfitPip?.value || selectedSlave?.slaveData?.takeProfitPip?.value === 0
            ? selectedSlave?.slaveData?.takeProfitPip?.value
            : '',
        copyTakeProfit:
          selectedSlave?.updatedValues?.copyTakeProfit?.value !== undefined
            ? !!selectedSlave?.updatedValues?.copyTakeProfit?.value
            : selectedSlave?.slaveData?.copyTakeProfit?.value !== undefined
            ? !!selectedSlave?.slaveData?.copyTakeProfit?.value
            : false,
        strictClose:
          selectedSlave?.updatedValues?.strictClose?.value !== undefined
            ? !!selectedSlave?.updatedValues?.strictClose?.value
            : selectedSlave?.slaveData?.strictClose?.value !== undefined
            ? !!selectedSlave?.slaveData?.strictClose?.value
            : false
      }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={() => {}}
    >
      {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => (
        <>
          {values.copyTakeProfit && !values.strictClose && <span style={{ textAlign: 'center', display: 'grid' }}>-</span>}
          {!(values.copyTakeProfit && !values.strictClose) && (
            <OutlinedInput
              sx={{ minWidth: 60 }}
              fullWidth
              error={Boolean(touched.fixedTakeProfitValue && errors.fixedTakeProfitValue)}
              // label={'Enter Fixed Take Profit'}
              inputProps={{ style: { minHeight: '14px', lineHeight: '12px', textAlign: 'center' } }}
              id="fixedTakeProfitValue"
              type="number"
              value={values.fixedTakeProfitValue || ''}
              name="fixedTakeProfitValue"
              onChange={(event) => {
                setFieldValue('fixedTakeProfitValue', +event.target.value);
              }}
              onBlur={(event) => {
                onFieldValue('takeProfitPip', { value: +values.fixedTakeProfitValue });
              }}
              placeholder="-"
              disabled={values.copyTakeProfit && !values.strictClose}
              readOnly={values.copyTakeProfit && !values.strictClose}
            />
          )}
        </>
      )}
    </Formik>
  );
};

const SLRefinementElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  return (
    <Formik
      initialValues={{
        stopLossRefinementValue:
          selectedSlave?.updatedValues?.slRefiner?.value || selectedSlave?.updatedValues?.slRefiner?.value === 0
            ? selectedSlave?.updatedValues?.slRefiner?.value
            : selectedSlave?.slaveData?.slRefiner?.value || selectedSlave?.slaveData?.slRefiner?.value === 0
            ? selectedSlave?.slaveData?.slRefiner?.value
            : 0,
        copyStopLoss:
          selectedSlave?.updatedValues?.copyStopLoss?.value !== undefined
            ? !!selectedSlave?.updatedValues?.copyStopLoss?.value
            : selectedSlave?.slaveData?.copyStopLoss?.value !== undefined
            ? !!selectedSlave?.slaveData?.copyStopLoss?.value
            : false
      }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={() => {}}
    >
      {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => (
        <>
          {!values.copyStopLoss && <span style={{ textAlign: 'center', display: 'grid' }}>-</span>}
          {values.copyStopLoss && (
            <OutlinedInput
              fullWidth
              error={Boolean(touched.stopLossRefinementValue && errors.stopLossRefinementValue)}
              inputProps={{ style: { minHeight: '14px', lineHeight: '12px', textAlign: 'center' } }}
              id="stopLossRefinementValue"
              type="number"
              value={values.stopLossRefinementValue || ''}
              name="stopLossRefinementValue"
              onBlur={() => {
                onFieldValue('slRefiner', { value: values.stopLossRefinementValue ? +values.stopLossRefinementValue : 0 });
              }}
              onChange={(event) => {
                setFieldValue('stopLossRefinementValue', +event.target.value);
              }}
              placeholder="-"
              disabled={!values.copyStopLoss}
              readOnly={!values.copyStopLoss}
            />
          )}
        </>
      )}
    </Formik>
  );
};

const TPRefinementElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  return (
    <Formik
      initialValues={{
        takeProfitRefinementValue:
          selectedSlave?.updatedValues?.tpRefiner?.value || selectedSlave?.updatedValues?.tpRefiner?.value === 0
            ? selectedSlave?.updatedValues?.tpRefiner?.value
            : selectedSlave?.slaveData?.tpRefiner?.value || selectedSlave?.slaveData?.tpRefiner?.value === 0
            ? selectedSlave?.slaveData?.tpRefiner?.value
            : 0,
        copyTakeProfit:
          selectedSlave?.updatedValues?.copyTakeProfit?.value !== undefined
            ? !!selectedSlave?.updatedValues?.copyTakeProfit?.value
            : selectedSlave?.slaveData?.copyTakeProfit?.value !== undefined
            ? !!selectedSlave?.slaveData?.copyTakeProfit?.value
            : false
      }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={() => {}}
    >
      {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => (
        <>
          {!values.copyTakeProfit && <span style={{ textAlign: 'center', display: 'grid' }}>-</span>}
          {values.copyTakeProfit && (
            <OutlinedInput
              fullWidth
              error={Boolean(touched.takeProfitRefinementValue && errors.takeProfitRefinementValue)}
              // label={'Enter Refinement'}
              inputProps={{ style: { minHeight: '14px', lineHeight: '12px', textAlign: 'center' } }}
              id="takeProfitRefinementValue"
              type="number"
              value={values.takeProfitRefinementValue || ''}
              name="takeProfitRefinementValue"
              onBlur={() => {
                onFieldValue('tpRefiner', { value: values.takeProfitRefinementValue ? +values.takeProfitRefinementValue : 0 });
              }}
              onChange={(event) => {
                setFieldValue('takeProfitRefinementValue', +event.target.value);
              }}
              placeholder="-"
              disabled={!values.copyTakeProfit}
              readOnly={!values.copyTakeProfit}
            />
          )}
        </>
      )}
    </Formik>
  );
};

const ForceMinimumLotElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  return (
    <Formik
      initialValues={{
        forceMinimumLotSize:
          selectedSlave?.updatedValues?.forceMinimumLotSize?.value !== undefined
            ? selectedSlave?.updatedValues?.forceMinimumLotSize?.value
            : selectedSlave?.slaveData?.forceMinimumLotSize?.value !== undefined
            ? selectedSlave?.slaveData?.forceMinimumLotSize?.value
            : false
      }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={() => {}}
    >
      {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => (
        <>
          <Checkbox
            name="forceMinimumLotSize"
            sx={{ margin: 'auto', display: 'grid' }}
            checked={values.forceMinimumLotSize}
            onChange={(event, checked) => {
              onFieldValue('forceMinimumLotSize', { value: checked });
            }}
          />
        </>
      )}
    </Formik>
  );
};

const ForceMaximumLotElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  return (
    <Formik
      initialValues={{
        forceMaximumLotSize:
          selectedSlave?.updatedValues?.forceMaximumLotSize?.value !== undefined
            ? selectedSlave?.updatedValues?.forceMaximumLotSize?.value
            : selectedSlave?.slaveData?.forceMaximumLotSize?.value !== undefined
            ? selectedSlave?.slaveData?.forceMaximumLotSize?.value
            : false
      }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={() => {}}
    >
      {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => (
        <>
          <Checkbox
            name="forceMaximumLotSize"
            sx={{ margin: 'auto', display: 'grid' }}
            checked={values.forceMaximumLotSize}
            onChange={(event, checked) => {
              onFieldValue('forceMaximumLotSize', { value: checked });
            }}
          />
        </>
      )}
    </Formik>
  );
};

const ReverseTradeElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  return (
    <Formik
      initialValues={{
        reverseTrade:
          selectedSlave?.updatedValues?.reverseTrade?.value !== undefined
            ? selectedSlave?.updatedValues?.reverseTrade?.value
            : selectedSlave?.slaveData?.reverseTrade?.value !== undefined
            ? selectedSlave?.slaveData?.reverseTrade?.value
            : false
      }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={() => {}}
    >
      {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => (
        <>
          <Checkbox
            name="reverseTrade"
            sx={{ margin: 'auto', display: 'grid' }}
            checked={values.reverseTrade}
            onChange={(event, checked) => {
              onFieldValue('reverseTrade', { value: checked });
              if (checked) {
                onFieldValue('copyStopLoss', { value: false });
                onFieldValue('copyTakeProfit', { value: false });
                onFieldValue('copyPendingOrders', { value: false });
              }
            }}
          />
        </>
      )}
    </Formik>
  );
};

const ContractAllignmentElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  return (
    <Formik
      initialValues={{
        considerContractSize:
          selectedSlave?.updatedValues?.considerContractSize?.value !== undefined
            ? selectedSlave?.updatedValues?.considerContractSize?.value
            : selectedSlave?.slaveData?.considerContractSize?.value !== undefined
            ? selectedSlave?.slaveData?.considerContractSize?.value
            : false,
        riskType: selectedSlave?.updatedValues?.riskType?.value
          ? riskTypeMapFromKey[selectedSlave?.updatedValues?.riskType?.value]
          : selectedSlave?.riskType
          ? riskTypeMapFromDisplayText[selectedSlave?.riskType]
          : ''
      }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={() => {}}
    >
      {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => (
        <>
          <Checkbox
            name="considerContractSize"
            sx={{ margin: 'auto', display: 'grid' }}
            checked={values.considerContractSize}
            disabled={+values.riskType === RISK_TYPE.BALANCE_PERCENTAGE}
            onChange={(event, checked) => {
              onFieldValue('considerContractSize', { value: checked });
            }}
          />
        </>
      )}
    </Formik>
  );
};

const CopyExpiryElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  return (
    <Formik
      initialValues={{
        copyExpiryTime:
          selectedSlave?.updatedValues?.copyExpiryTime?.value !== undefined
            ? selectedSlave?.updatedValues?.copyExpiryTime?.value
            : selectedSlave?.slaveData?.copyExpiryTime?.value !== undefined
            ? selectedSlave?.slaveData?.copyExpiryTime?.value
            : false
      }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={() => {}}
    >
      {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => (
        <>
          <Checkbox
            name="copyExpiryTime"
            sx={{ margin: 'auto', display: 'grid' }}
            checked={values.copyExpiryTime}
            onChange={(event, checked) => {
              onFieldValue('copyExpiryTime', { value: checked });
            }}
          />
        </>
      )}
    </Formik>
  );
};

const StrictCloseElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  return (
    <Formik
      initialValues={{
        strictClose:
          selectedSlave?.updatedValues?.strictClose?.value !== undefined
            ? selectedSlave?.updatedValues?.strictClose?.value
            : selectedSlave?.slaveData?.strictClose?.value !== undefined
            ? selectedSlave?.slaveData?.strictClose?.value
            : false,
        fixedStopLossValue:
          selectedSlave?.updatedValues?.stopLossPip?.value || selectedSlave?.updatedValues?.stopLossPip?.value === 0
            ? selectedSlave?.updatedValues?.stopLossPip?.value
            : selectedSlave?.slaveData?.stopLossPip?.value || selectedSlave?.slaveData?.stopLossPip?.value === 0
            ? selectedSlave?.slaveData?.stopLossPip?.value
            : 0,
        fixedTakeProfitValue:
          selectedSlave?.updatedValues?.takeProfitPip?.value || selectedSlave?.updatedValues?.takeProfitPip?.value === 0
            ? selectedSlave?.updatedValues?.takeProfitPip?.value
            : selectedSlave?.slaveData?.takeProfitPip?.value || selectedSlave?.slaveData?.takeProfitPip?.value === 0
            ? selectedSlave?.slaveData?.takeProfitPip?.value
            : 0
      }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={() => {}}
    >
      {({ values, handleChange, handleBlur, errors, touched, setFieldValue }) => (
        <>
          <Checkbox
            name="strictClose"
            sx={{ margin: 'auto', display: 'grid' }}
            checked={values.strictClose}
            onChange={(event, checked) => {
              if (checked) {
                if (values.fixedStopLossValue === 0) {
                  setFieldValue('copyStopLoss', { value: true });
                }
                if (values.fixedTakeProfitValue === 0) {
                  setFieldValue('copyTakeProfit', { value: true });
                }
              }
              onFieldValue('strictClose', { value: checked });
            }}
          />
        </>
      )}
    </Formik>
  );
};

const CopyCommentSelectorElement = (index: number, selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  const getCopyComment = () => {
    const updatedValues = selectedSlave?.updatedValues;
    const slaveData = selectedSlave?.slaveData;

    const copyComment = updatedValues?.copyComment?.value ?? slaveData?.copyComment?.value;
    const customComment =
      updatedValues?.customComment?.value || updatedValues?.customComment?.value === '' || updatedValues?.customComment?.value === null
        ? updatedValues?.customComment?.value
        : slaveData?.customComment?.value
        ? slaveData?.customComment?.value
        : null;

    if (selectedSlave?.copyComment) {
      return selectedSlave.copyComment;
    }

    if (copyComment !== undefined && customComment !== undefined) {
      if (copyComment && (customComment || customComment === '')) {
        return 'Custom';
      }
      return copyComment ? 'Yes' : 'No';
    }

    return 'No';
  };

  return (
    <>
      <Formik
        initialValues={{
          copyCommentSelector: getCopyComment()
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors, touched, setFieldValue, resetForm }) => (
          <Select
            sx={{ width: 100, textAlign: 'center' }}
            labelId="copyCommentSelector"
            id="copyCommentSelector"
            name="copyCommentSelector"
            value={values.copyCommentSelector}
            // onBlur={handleBlur}
            // onChange={handleChange}
            onChange={(e, v) => {
              onFieldValue('copyComment', e?.target?.value, true);
              onFieldValue('copyComment', { value: e?.target?.value !== 'No' });
              onFieldValue('customComment', { value: e?.target?.value === 'Custom' ? '' : null });
            }}
            error={Boolean(touched.copyCommentSelector && errors.copyCommentSelector)}
          >
            {index === 0 && (
              <MenuItem disabled defaultChecked={true} value={'null'}>
                Select
              </MenuItem>
            )}
            <MenuItem value={'No'}>No</MenuItem>
            <MenuItem value={'Yes'}>Yes</MenuItem>
            <MenuItem value={'Custom'}>Custom</MenuItem>
          </Select>
        )}
      </Formik>
    </>
  );
};

const CopyCustomCommentElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  const getCopyComment = () => {
    const updatedValues = selectedSlave?.updatedValues;
    const slaveData = selectedSlave?.slaveData;

    const copyComment = updatedValues?.copyComment?.value ?? slaveData?.copyComment?.value;
    const customComment =
      updatedValues?.customComment?.value || updatedValues?.customComment?.value === '' || updatedValues?.customComment?.value === null
        ? updatedValues?.customComment?.value
        : slaveData?.customComment?.value
        ? slaveData?.customComment?.value
        : null;

    if (copyComment !== undefined && customComment !== undefined) {
      if (copyComment && (customComment || customComment === '')) {
        return 'Custom';
      }
      return copyComment ? 'Yes' : 'No';
    }

    return 'No';
  };
  return (
    <>
      <Formik
        initialValues={{
          customComment:
            selectedSlave?.updatedValues?.customComment?.value !== undefined
              ? selectedSlave?.updatedValues?.customComment?.value
              : selectedSlave?.slaveData?.customComment?.value !== undefined
              ? selectedSlave?.slaveData?.customComment?.value
              : '',
          copyCommentSelector: getCopyComment()
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors, touched, handleChange, setFieldValue, resetForm }) => (
          <>
            {values.copyCommentSelector !== 'Custom' && <span style={{ width: 220, display: 'grid', textAlign: 'center' }}>-</span>}
            {values.copyCommentSelector === 'Custom' && (
              <OutlinedInput
                sx={{ width: 220 }}
                fullWidth
                error={Boolean(touched.customComment && errors.customComment)}
                inputProps={{ style: { minHeight: '14px', lineHeight: '12px' } }}
                id="custom-comment"
                type="text"
                value={values?.copyCommentSelector === 'Custom' ? values.customComment : ''}
                name="customComment"
                onBlur={() => {
                  onFieldValue('customComment', { value: values.customComment });
                }}
                onChange={handleChange}
                placeholder="Custom Comment"
                disabled={values.copyCommentSelector !== 'Custom'}
                readOnly={values.copyCommentSelector !== 'Custom'}
              />
            )}
          </>
        )}
      </Formik>
    </>
  );
};

const CopyMagicNumberElement = (index: number, selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  const getCopyMagicNumber = () => {
    const updatedValues = selectedSlave?.updatedValues;
    const slaveData = selectedSlave?.slaveData;

    if (selectedSlave.copyMagic) {
      return selectedSlave.copyMagic;
    }

    const copyMagicNumber = updatedValues?.copyMagicNumber?.value ?? slaveData?.copyMagicNumber?.value;
    const magicNumber =
      updatedValues?.magicNumber?.value || updatedValues?.magicNumber?.value === 0 || updatedValues?.magicNumber?.value === null
        ? updatedValues?.magicNumber?.value
        : slaveData?.magicNumber?.value
        ? slaveData?.magicNumber?.value
        : null;

    if (copyMagicNumber !== undefined && magicNumber !== undefined) {
      if (copyMagicNumber && (magicNumber || magicNumber === 0)) {
        return 'Custom';
      }
      return copyMagicNumber ? 'Yes' : 'No';
    }

    return 'No';
  };

  return (
    <>
      <Formik
        initialValues={{
          copyMagicNumber: getCopyMagicNumber()
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors, touched, setFieldValue, resetForm }) => (
          <Select
            sx={{ width: 100, textAlign: 'center' }}
            labelId="copyMagicNumber"
            id="copyMagicNumber"
            name="copyMagicNumber"
            value={values.copyMagicNumber}
            // onBlur={handleBlur}
            // onChange={handleChange}
            onChange={(e, v) => {
              onFieldValue('copyMagic', e?.target?.value, true);
              onFieldValue('copyMagicNumber', { value: e?.target?.value !== 'No' });
              onFieldValue('magicNumber', { value: e?.target?.value === 'Custom' ? 0 : null });
            }}
            error={Boolean(touched.copyMagicNumber && errors.copyMagicNumber)}
          >
            {index === 0 && (
              <MenuItem disabled defaultChecked={true} value={'null'}>
                Select
              </MenuItem>
            )}
            <MenuItem value={'No'}>No</MenuItem>
            <MenuItem value={'Yes'}>Yes</MenuItem>
            <MenuItem value={'Custom'}>Custom</MenuItem>
          </Select>
        )}
      </Formik>
    </>
  );
};

const CustomMagicNumberElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  const getCopyMagicNumber = () => {
    const updatedValues = selectedSlave?.updatedValues;
    const slaveData = selectedSlave?.slaveData;

    if (selectedSlave.customMagicType) {
      return selectedSlave.customMagicType;
    }

    const copyMagicNumber = updatedValues?.copyMagicNumber?.value ?? slaveData?.copyMagicNumber?.value;
    const magicNumber =
      updatedValues?.magicNumber?.value || updatedValues?.magicNumber?.value === 0 || updatedValues?.magicNumber?.value === null
        ? updatedValues?.magicNumber?.value
        : slaveData?.magicNumber?.value
        ? slaveData?.magicNumber?.value
        : null;

    if (copyMagicNumber !== undefined && magicNumber !== undefined) {
      if (copyMagicNumber && (magicNumber || magicNumber === 0)) {
        return 'Custom';
      }
      return copyMagicNumber ? 'Yes' : 'No';
    }

    return 'No';
  };
  return (
    <>
      <Formik
        initialValues={{
          magicNumber:
            selectedSlave?.updatedValues?.magicNumber?.value !== undefined
              ? selectedSlave?.updatedValues?.magicNumber?.value
              : selectedSlave?.slaveData?.magicNumber?.value !== undefined
              ? selectedSlave?.slaveData?.magicNumber?.value
              : '',
          copyMagicNumeber: getCopyMagicNumber()
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors, touched, handleChange, setFieldValue, resetForm }) => (
          <>
            {values.copyMagicNumeber !== 'Custom' && <span style={{ width: 80, display: 'grid', textAlign: 'center' }}>-</span>}
            {values.copyMagicNumeber === 'Custom' && (
              <OutlinedInput
                sx={{ width: 80 }}
                fullWidth
                error={Boolean(touched.magicNumber && errors.magicNumber)}
                inputProps={{ style: { minHeight: '14px', lineHeight: '12px', textAlign: 'center' } }}
                id="magicNumber"
                type="number"
                value={values?.copyMagicNumeber === 'Custom' ? values.magicNumber : ''}
                name="magicNumber"
                onBlur={() => {
                  onFieldValue('magicNumber', { value: values.magicNumber });
                }}
                placeholder="-"
                onChange={handleChange}
                disabled={values.copyMagicNumeber !== 'Custom'}
                readOnly={values.copyMagicNumeber !== 'Custom'}
              />
            )}
          </>
        )}
      </Formik>
    </>
  );
};

const DelayTypeElement = (index: number, selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  const getDelayType = () => {
    const updatedValues = selectedSlave?.updatedValues;
    const slaveData = selectedSlave?.slaveData;

    const minDelay =
      updatedValues?.minDelayTime?.value || updatedValues?.minDelayTime?.value === 0 || updatedValues?.minDelayTime?.value === null
        ? updatedValues?.minDelayTime?.value
        : slaveData?.minDelayTime?.value
        ? slaveData?.minDelayTime?.value
        : 0;
    const maxDelay =
      updatedValues?.maxDelayTime?.value || updatedValues?.maxDelayTime?.value === 0 || updatedValues?.maxDelayTime?.value === null
        ? updatedValues?.maxDelayTime?.value
        : slaveData?.maxDelayTime?.value
        ? slaveData?.maxDelayTime?.value
        : 0;

    if (selectedSlave.delayType) {
      return selectedSlave.delayType;
    }

    if (minDelay === 0 && maxDelay === 0) {
      return 'no';
    }
    if (minDelay > 0 && maxDelay > 0 && minDelay === maxDelay) {
      return 'fixed';
    }
    return 'random';
  };

  return (
    <>
      <Formik
        initialValues={{
          delayType: getDelayType()
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors, touched, setFieldValue, resetForm }) => (
          <Select
            sx={{ textAlign: 'center', width: 180 }}
            labelId="delayType"
            id="delayType"
            name="delayType"
            value={values.delayType}
            // onBlur={handleBlur}
            onChange={(e, v) => {
              onFieldValue('delayType', e.target.value, true);
              if (e.target.value === 'no') {
                onFieldValue('minDelayTime', { value: 0 });
                onFieldValue('maxDelayTime', { value: 0 });
              } else if (e.target.value === 'fixed') {
                onFieldValue('minDelayTime', { value: 0 });
                onFieldValue('maxDelayTime', { value: 0 });
              } else {
                onFieldValue('minDelayTime', { value: 0 });
                onFieldValue('maxDelayTime', { value: 0 });
              }
            }}
            error={Boolean(touched.delayType && errors.delayType)}
          >
            {index === 0 && (
              <MenuItem disabled value={'null'}>
                Select an option
              </MenuItem>
            )}
            <MenuItem value={'no'}>No trade delay</MenuItem>
            <MenuItem value={'fixed'}>Fixed trade delay</MenuItem>
            <MenuItem value={'random'}>Random trade delay</MenuItem>
          </Select>
        )}
      </Formik>
    </>
  );
};

const TradeDelayElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  const getDelayType = () => {
    const updatedValues = selectedSlave?.updatedValues;
    const slaveData = selectedSlave?.slaveData;

    const minDelay =
      updatedValues?.minDelayTime?.value || updatedValues?.minDelayTime?.value === 0 || updatedValues?.minDelayTime?.value === null
        ? updatedValues?.minDelayTime?.value
        : slaveData?.minDelayTime?.value
        ? slaveData?.minDelayTime?.value
        : 0;
    const maxDelay =
      updatedValues?.maxDelayTime?.value || updatedValues?.maxDelayTime?.value === 0 || updatedValues?.maxDelayTime?.value === null
        ? updatedValues?.maxDelayTime?.value
        : slaveData?.maxDelayTime?.value
        ? slaveData?.maxDelayTime?.value
        : 0;

    if (selectedSlave.delayType) {
      return selectedSlave.delayType;
    }

    if (minDelay === 0 && maxDelay === 0) {
      return 'no';
    }
    if (minDelay > 0 && maxDelay > 0 && minDelay === maxDelay) {
      return 'fixed';
    }
    return 'random';
  };
  return (
    <>
      <Formik
        initialValues={{
          minDelay:
            selectedSlave?.updatedValues?.minDelayTime?.value !== undefined
              ? selectedSlave?.updatedValues?.minDelayTime?.value
              : selectedSlave?.slaveData?.minDelayTime?.value !== undefined
              ? selectedSlave?.slaveData?.minDelayTime?.value
              : '',
          maxDelay:
            selectedSlave?.updatedValues?.maxDelayTime?.value !== undefined
              ? selectedSlave?.updatedValues?.maxDelayTime?.value
              : selectedSlave?.slaveData?.maxDelayTime?.value !== undefined
              ? selectedSlave?.slaveData?.maxDelayTime?.value
              : '',
          delayType: getDelayType()
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors, touched, handleChange, setFieldValue, resetForm }) => (
          <>
            {values.delayType === 'no' && <span style={{ width: 130, display: 'grid', textAlign: 'center' }}>-</span>}
            {values.delayType !== 'no' && (
              <Grid sx={{ width: 130, display: 'flex' }}>
                <OutlinedInput
                  sx={{ width: values.delayType === 'random' ? 60 : 130, marginRight: values.delayType === 'random' ? '10px' : 0 }}
                  fullWidth
                  error={Boolean(touched.minDelay && errors.minDelay)}
                  inputProps={{ style: { minHeight: '14px', lineHeight: '12px', textAlign: 'center' } }}
                  id="minDelay"
                  type="number"
                  value={values.minDelay || ''}
                  placeholder="-"
                  name="minDelay"
                  onBlur={() => {
                    onFieldValue('minDelayTime', { value: values.minDelay });
                    if (values.delayType === 'fixed') {
                      onFieldValue('maxDelayTime', { value: values.minDelay });
                    }
                  }}
                  onChange={handleChange}
                />
                {values.delayType === 'random' && (
                  <OutlinedInput
                    sx={{ width: 60 }}
                    fullWidth
                    error={Boolean(touched.maxDelay && errors.maxDelay)}
                    inputProps={{ style: { minHeight: '14px', lineHeight: '12px', textAlign: 'center' } }}
                    id="maxDelay"
                    type="number"
                    value={values.maxDelay || ''}
                    placeholder="-"
                    name="maxDelay"
                    onBlur={() => {
                      onFieldValue('maxDelayTime', { value: values.maxDelay });
                    }}
                    onChange={handleChange}
                    disabled={values.delayType !== 'random'}
                    readOnly={values.delayType !== 'random'}
                  />
                )}
              </Grid>
            )}
          </>
        )}
      </Formik>
    </>
  );
};

// const CustomPlacedTypeElement = (index: number, selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
//   const validationSchema = Yup.object().shape({});
//   // eslint-disable-next-line @typescript-eslint/no-unused-vars
//   const [customPlacedTypes, setCustomPlacedTypes] = useState(
//     selectedSlave?.placedTypeOptions && selectedSlave?.placedTypeOptions.length > 0
//       ? selectedSlave?.placedTypeOptions
//       : selectedSlave?.slaveData?.platform === 'MT-4'
//       ? mt4Options
//       : selectedSlave?.slaveData?.platform === 'MT-5'
//       ? mt5Options
//       : []
//   );
//   return (
//     <>
//       <Formik
//         initialValues={{
//           customPlacedType:
//             index === 0 &&
//             (selectedSlave?.updatedValues?.placedType?.value === undefined || selectedSlave?.updatedValues?.placedType?.value === null)
//               ? 'null'
//               : selectedSlave?.updatedValues?.placedType?.value
//               ? selectedSlave?.updatedValues?.placedType?.value
//               : selectedSlave?.slaveData?.placedType?.value
//               ? selectedSlave?.slaveData?.placedType?.value
//               : 'no'
//         }}
//         enableReinitialize
//         validationSchema={validationSchema}
//         onSubmit={() => {}}
//       >
//         {({ values, errors, touched, setFieldValue, resetForm }) => (
//           <Select
//             sx={{ textAlign: 'center', width: 180 }}
//             id="customPlacedType"
//             name="customPlacedType"
//             value={values.customPlacedType || ''}
//             defaultValue={''}
//             // onBlur={handleBlur}
//             onChange={(e, v) => {
//               onFieldValue('placedType', { value: e?.target?.value });
//             }}
//             error={Boolean(touched.customPlacedType && errors.customPlacedType)}
//           >
//             {index === 0 && (
//               <MenuItem disabled defaultValue={''} defaultChecked={true} value={'null'}>
//                 Select an option
//               </MenuItem>
//             )}
//             <MenuItem value={'no'}>Copy from Master</MenuItem>
//             {customPlacedTypes.map((x) => {
//               return <MenuItem value={x.value}>{x.name}</MenuItem>;
//             })}
//           </Select>
//         )}
//       </Formik>
//     </>
//   );
// };

const LotRefinerElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  return (
    <>
      <Formik
        initialValues={{
          lotRefiner:
            selectedSlave?.updatedValues?.lotRefinerValue?.value !== undefined || selectedSlave?.updatedValues?.lotRefinerValue?.value === 0
              ? selectedSlave?.updatedValues?.lotRefinerValue?.value
              : selectedSlave?.slaveData?.lotRefinerValue?.value !== undefined || selectedSlave?.slaveData?.lotRefinerValue?.value === 0
              ? selectedSlave?.slaveData?.lotRefinerValue?.value
              : ''
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors, touched, handleChange, setFieldValue, resetForm }) => (
          <>
            <OutlinedInput
              fullWidth
              sx={{ width: 80 }}
              error={Boolean(touched.lotRefiner && errors.lotRefiner)}
              inputProps={{ style: { minHeight: '14px', lineHeight: '12px', textAlign: 'center' } }}
              id="lotRefiner"
              type="number"
              placeholder="-"
              value={values.lotRefiner || ''}
              name="lotRefiner"
              onBlur={() => {
                onFieldValue('lotRefinerValue', { value: +values?.lotRefiner || 0 });
              }}
              onChange={handleChange}
            />
          </>
        )}
      </Formik>
    </>
  );
};

const MagicFiltersElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});

  useEffect(() => {
    if (selectedSlave && selectedSlave?.updatedValues && selectedSlave?.updatedValues?.magicFiltersList?.length > 0) {
      setSelectedMagicNumbers(selectedSlave?.updatedValues?.magicFiltersList.map((e) => e.value?.toString()));
    } else if (selectedSlave && selectedSlave?.updatedValues && selectedSlave?.updatedValues?.magicFiltersList !== undefined) {
      setSelectedMagicNumbers(selectedSlave?.updatedValues?.magicFiltersList?.map((e) => e.value?.toString()) || []);
    } else if (selectedSlave && selectedSlave?.slaveData && selectedSlave?.slaveData?.magicFiltersList.length > 0) {
      setSelectedMagicNumbers(selectedSlave?.slaveData?.magicFiltersList.map((e) => e.value?.toString()));
    }
  }, []);

  const [selectedMagicNumbers, setSelectedMagicNumbers] = useState<string[]>([]);
  const [currentMagicNumber, setCurrentMagicNumber] = useState('');

  return (
    <>
      <Formik
        initialValues={{
          magicFilterValue: ''
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors, touched, handleChange, setFieldValue, resetForm }) => (
          <>
            <Autocomplete
              multiple
              id="magicFilterValue"
              open={false}
              forcePopupIcon={false}
              clearText={'Remove all'}
              options={selectedMagicNumbers}
              value={selectedMagicNumbers}
              getOptionLabel={(option: any) => option}
              defaultValue={selectedMagicNumbers}
              onChange={(event, value) => {
                setSelectedMagicNumbers(value);
                const val: Int64Value.AsObject[] = value.map((x) => {
                  return { value: +x };
                });
                onFieldValue('magicFiltersList', val);
              }}
              onBlur={() => {}}
              renderInput={(params) => {
                return (
                  <TextField
                    {...params}
                    placeholder="Press enter to add"
                    value={currentMagicNumber}
                    type="number"
                    onChange={(e) => {
                      setCurrentMagicNumber(e.target.value);
                    }}
                    onBlur={() => {
                      if (currentMagicNumber && !selectedMagicNumbers.includes(currentMagicNumber) && selectedMagicNumbers?.length < 10) {
                        const val: Int64Value.AsObject[] = [...selectedMagicNumbers, currentMagicNumber].map((x) => {
                          return { value: +x };
                        });
                        onFieldValue('magicFiltersList', val);
                        return;
                      }
                      const val: Int64Value.AsObject[] = selectedMagicNumbers.map((x) => {
                        return { value: +x };
                      });
                      onFieldValue('magicFiltersList', val);
                    }}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        if (currentMagicNumber && !selectedMagicNumbers.includes(currentMagicNumber) && selectedMagicNumbers?.length < 10) {
                          setSelectedMagicNumbers((prev) => [...prev, currentMagicNumber]);
                          setCurrentMagicNumber('');
                        }
                      }
                    }}
                  />
                );
              }}
              sx={{
                width: 220,
                '& .MuiAutocomplete-tag': {
                  bgcolor: 'primary.lighter',
                  border: '1px solid',
                  borderRadius: 1,
                  height: 32,
                  pl: 1.5,
                  pr: 1.5,
                  lineHeight: '32px',
                  borderColor: 'primary.light',
                  '& .MuiChip-label': {
                    paddingLeft: 0,
                    paddingRight: 0
                  },
                  '& .MuiSvgIcon-root': {
                    color: 'primary.main',
                    ml: 1,
                    mr: -0.75,
                    '&:hover': {
                      color: 'primary.dark'
                    }
                  }
                }
              }}
            />
          </>
        )}
      </Formik>
    </>
  );
};

const CommentFiltersElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});

  useEffect(() => {
    if (selectedSlave && selectedSlave?.updatedValues && selectedSlave?.updatedValues?.commentFiltersList?.length > 0) {
      setSelectedComments(selectedSlave?.updatedValues?.commentFiltersList.map((e) => e.value?.toString()));
    } else if (selectedSlave && selectedSlave?.updatedValues && selectedSlave?.updatedValues?.commentFiltersList !== undefined) {
      setSelectedComments(selectedSlave?.updatedValues?.commentFiltersList?.map((e) => e.value?.toString()) || []);
    } else if (selectedSlave && selectedSlave?.slaveData && selectedSlave?.slaveData?.commentFiltersList.length > 0) {
      setSelectedComments(selectedSlave?.slaveData?.commentFiltersList.map((e) => e.value?.toString()));
    }
  }, []);

  const [selectedComments, setSelectedComments] = useState<string[]>([]);
  const [currentComment, setCurrentComment] = useState('');

  return (
    <>
      <Formik
        initialValues={{
          filterByCommentValue: ''
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors, touched, handleChange, setFieldValue, resetForm }) => (
          <>
            <Autocomplete
              multiple
              id="filterByCommentValue"
              open={false}
              forcePopupIcon={false}
              clearText={'Remove all'}
              options={selectedComments}
              value={selectedComments}
              getOptionLabel={(option: any) => option}
              defaultValue={selectedComments}
              onChange={(event, value) => {
                setSelectedComments(value);
                const val: StringValue.AsObject[] = value.map((x) => {
                  return { value: x };
                });
                onFieldValue('commentFiltersList', val);
              }}
              onBlur={async (e) => {}}
              renderInput={(params) => {
                return (
                  <TextField
                    {...params}
                    placeholder="Press enter to add"
                    value={currentComment}
                    onChange={(e) => {
                      setCurrentComment(e.target.value);
                    }}
                    onBlur={(e) => {
                      if (currentComment && !selectedComments.includes(currentComment) && selectedComments.length < 10) {
                        const val: StringValue.AsObject[] = [...selectedComments, currentComment].map((x) => {
                          return { value: x };
                        });
                        onFieldValue('commentFiltersList', val);
                        return;
                      }
                      const val: StringValue.AsObject[] = selectedComments.map((x) => {
                        return { value: x };
                      });
                      onFieldValue('commentFiltersList', val);
                    }}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        if (currentComment && !selectedComments.includes(currentComment) && selectedComments.length < 10) {
                          setSelectedComments((prev) => [...prev, currentComment]);
                          setCurrentComment('');
                        }
                      }
                    }}
                  />
                );
              }}
              sx={{
                width: 280,
                textAlign: 'center',
                '& .MuiAutocomplete-tag': {
                  bgcolor: 'primary.lighter',
                  border: '1px solid',
                  borderRadius: 1,
                  height: 32,
                  pl: 1.5,
                  pr: 1.5,
                  lineHeight: '32px',
                  borderColor: 'primary.light',
                  '& .MuiChip-label': {
                    paddingLeft: 0,
                    paddingRight: 0
                  },
                  '& .MuiSvgIcon-root': {
                    color: 'primary.main',
                    ml: 1,
                    mr: -0.75,
                    '&:hover': {
                      color: 'primary.dark'
                    }
                  }
                }
              }}
            />
          </>
        )}
      </Formik>
    </>
  );
};

const LotFilterElement = (selectedSlave: CopyTradingTableDto, onBlur: any, onChange: any, onFieldValue: any) => {
  const validationSchema = Yup.object().shape({});
  return (
    <>
      <Formik
        initialValues={{
          filterByLotSizeMinValue:
            selectedSlave?.updatedValues?.minLotFilter?.value !== undefined || selectedSlave?.updatedValues?.minLotFilter?.value === 0
              ? selectedSlave?.updatedValues?.minLotFilter?.value
              : selectedSlave?.slaveData?.minLotFilter?.value !== undefined || selectedSlave?.slaveData?.minLotFilter?.value === 0
              ? selectedSlave?.slaveData?.minLotFilter?.value
              : '',
          filterByLotSizeMaxValue:
            selectedSlave?.updatedValues?.maxLotFilter?.value !== undefined || selectedSlave?.updatedValues?.maxLotFilter?.value === 0
              ? selectedSlave?.updatedValues?.maxLotFilter?.value
              : selectedSlave?.slaveData?.maxLotFilter?.value !== undefined || selectedSlave?.slaveData?.maxLotFilter?.value === 0
              ? selectedSlave?.slaveData?.maxLotFilter?.value
              : ''
        }}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={() => {}}
      >
        {({ values, errors, touched, handleChange, setFieldValue, resetForm }) => (
          <>
            <Grid sx={{ width: 130, display: 'flex' }}>
              <OutlinedInput
                fullWidth
                sx={{ width: 60, marginRight: '10px' }}
                error={Boolean(touched.filterByLotSizeMinValue && errors.filterByLotSizeMinValue)}
                inputProps={{ style: { minHeight: '14px', lineHeight: '12px', textAlign: 'center' } }}
                id="filterByLotSizeMinValue"
                type="number"
                placeholder="-"
                value={values.filterByLotSizeMinValue || ''}
                name="filterByLotSizeMinValue"
                onBlur={() => {
                  onFieldValue('minLotFilter', { value: +values.filterByLotSizeMinValue || 0 });
                }}
                onChange={handleChange}
                //   disabled={values.filterByLotSize !== 'Yes'}
                //   readOnly={values.filterByLotSize !== 'Yes'}
              />
              <OutlinedInput
                fullWidth
                sx={{ width: 60 }}
                error={Boolean(touched.filterByLotSizeMaxValue && errors.filterByLotSizeMaxValue)}
                inputProps={{ style: { minHeight: '14px', lineHeight: '12px', textAlign: 'center' } }}
                id="filterByLotSizeMaxValue"
                type="number"
                placeholder="-"
                value={values.filterByLotSizeMaxValue || ''}
                name="filterByLotSizeMaxValue"
                onBlur={() => {
                  onFieldValue('maxLotFilter', { value: +values.filterByLotSizeMaxValue || 0 });
                }}
                onChange={handleChange}
                //   disabled={values.filterByLotSize !== 'Yes'}
                //   readOnly={values.filterByLotSize !== 'Yes'}
              />
            </Grid>
          </>
        )}
      </Formik>
    </>
  );
};

export default BulkEditSlaveTable;
